/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PathRouteImport } from './routes/path'
import { Route as IntroductionRouteImport } from './routes/introduction'
import { Route as AudienceRouteImport } from './routes/audience'
import { Route as AppRouteImport } from './routes/app'
import { Route as TrainerRouteRouteImport } from './routes/trainer/route'
import { Route as contentRouteRouteImport } from './routes/(content)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrainerProfileRouteImport } from './routes/trainer/profile'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as contentProfileRouteImport } from './routes/(content)/profile'
import { Route as contentGetHelpRouteImport } from './routes/(content)/get-help'
import { Route as contentStudyRouteRouteImport } from './routes/(content)/study/route'
import { Route as contentChildrenRouteRouteImport } from './routes/(content)/children/route'
import { Route as contentAdultsRouteRouteImport } from './routes/(content)/adults/route'
import { Route as TrainerNotesIndexRouteImport } from './routes/trainer/notes/index'
import { Route as TrainerCoursesIndexRouteImport } from './routes/trainer/courses/index'
import { Route as TrainerAuthIndexRouteImport } from './routes/trainer/auth/index'
import { Route as contentStudyIndexRouteImport } from './routes/(content)/study/index'
import { Route as TrainerNotesCourseSlugRouteImport } from './routes/trainer/notes/$courseSlug'
import { Route as TrainerAuthRegisterRouteImport } from './routes/trainer/auth/register'
import { Route as TrainerAuthLoginRouteImport } from './routes/trainer/auth/login'
import { Route as contentStudyDoneRouteImport } from './routes/(content)/study/done'
import { Route as contentStudyWaveRouteImport } from './routes/(content)/study/$wave'
import { Route as TrainerCoursesCourseSlugIndexRouteImport } from './routes/trainer/courses/$courseSlug/index'
import { Route as contentChildrenSessionIndexRouteImport } from './routes/(content)/children/session/index'
import { Route as contentChildrenExercisesIndexRouteImport } from './routes/(content)/children/exercises/index'
import { Route as contentAdultsExercisesIndexRouteImport } from './routes/(content)/adults/exercises/index'
import { Route as TrainerCoursesCourseSlugPlayerRouteImport } from './routes/trainer/courses/$courseSlug/player'
import { Route as contentAdultsExercisesTraumaIndexRouteImport } from './routes/(content)/adults/exercises/trauma/index'
import { Route as contentAdultsExercisesSuicideIdeationIndexRouteImport } from './routes/(content)/adults/exercises/suicide-ideation/index'
import { Route as contentAdultsExercisesSubstanceUseIndexRouteImport } from './routes/(content)/adults/exercises/substance-use/index'
import { Route as contentAdultsExercisesSleepIndexRouteImport } from './routes/(content)/adults/exercises/sleep/index'
import { Route as contentAdultsExercisesSelfInflictedInjuriesIndexRouteImport } from './routes/(content)/adults/exercises/self-inflicted-injuries/index'
import { Route as contentAdultsExercisesPhysicalPainIndexRouteImport } from './routes/(content)/adults/exercises/physical-pain/index'
import { Route as contentAdultsExercisesNightmaresIndexRouteImport } from './routes/(content)/adults/exercises/nightmares/index'
import { Route as contentAdultsExercisesGuiltFeelingsIndexRouteImport } from './routes/(content)/adults/exercises/guilt-feelings/index'
import { Route as contentAdultsExercisesFlashbacksIndexRouteImport } from './routes/(content)/adults/exercises/flashbacks/index'
import { Route as contentAdultsExercisesDepressionIndexRouteImport } from './routes/(content)/adults/exercises/depression/index'
import { Route as contentAdultsExercisesConcentrationIndexRouteImport } from './routes/(content)/adults/exercises/concentration/index'
import { Route as contentAdultsExercisesAnxietyIndexRouteImport } from './routes/(content)/adults/exercises/anxiety/index'
import { Route as contentAdultsExercisesAngerIndexRouteImport } from './routes/(content)/adults/exercises/anger/index'
import { Route as contentChildrenExercisessharedTreeOfLifeIndexRouteImport } from './routes/(content)/children/exercises/(shared)/tree-of-life/index'
import { Route as contentChildrenExercisessharedStrengthsMapIndexRouteImport } from './routes/(content)/children/exercises/(shared)/strengths-map/index'
import { Route as contentChildrenExercisessharedSocialNetworkIndexRouteImport } from './routes/(content)/children/exercises/(shared)/social-network/index'
import { Route as contentChildrenExercisessharedRelaxationIndexRouteImport } from './routes/(content)/children/exercises/(shared)/relaxation/index'
import { Route as contentChildrenExercisessharedPersonalSourcesIndexRouteImport } from './routes/(content)/children/exercises/(shared)/personal-sources/index'
import { Route as contentChildrenExercisessharedMyBraveStoryIndexRouteImport } from './routes/(content)/children/exercises/(shared)/my-brave-story/index'
import { Route as contentChildrenExercisessharedHummingBeeBreathIndexRouteImport } from './routes/(content)/children/exercises/(shared)/humming-bee-breath/index'
import { Route as contentChildrenExercisessharedHappyPlaceIndexRouteImport } from './routes/(content)/children/exercises/(shared)/happy-place/index'
import { Route as contentChildrenExercisessharedGuidedRelaxationIndexRouteImport } from './routes/(content)/children/exercises/(shared)/guided-relaxation/index'
import { Route as contentChildrenExercisessharedGroundingWalkIndexRouteImport } from './routes/(content)/children/exercises/(shared)/grounding-walk/index'
import { Route as contentChildrenExercisessharedFingerBreathingIndexRouteImport } from './routes/(content)/children/exercises/(shared)/finger-breathing/index'
import { Route as contentChildrenExercisessharedDiaryChildrenIndexRouteImport } from './routes/(content)/children/exercises/(shared)/diary-children/index'
import { Route as contentChildrenExercisessharedCircleOfControlIndexRouteImport } from './routes/(content)/children/exercises/(shared)/circle-of-control/index'
import { Route as contentChildrenExercisessharedBodyExerciseIndexRouteImport } from './routes/(content)/children/exercises/(shared)/body-exercise/index'
import { Route as contentChildrenExercisessharedAngerIcebergIndexRouteImport } from './routes/(content)/children/exercises/(shared)/anger-iceberg/index'
import { Route as contentAdultsExercisessharedWaterfallIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/waterfall/index'
import { Route as contentAdultsExercisessharedTreeOfLifeIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/tree-of-life/index'
import { Route as contentAdultsExercisessharedThreeBreathIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/three-breath/index'
import { Route as contentAdultsExercisessharedSocialNetworkIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/social-network/index'
import { Route as contentAdultsExercisessharedRelaxationIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/relaxation/index'
import { Route as contentAdultsExercisessharedPositiveImageryIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/positive-imagery/index'
import { Route as contentAdultsExercisessharedPleasantMemoriesIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/pleasant-memories/index'
import { Route as contentAdultsExercisessharedPersonalSourcesIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/personal-sources/index'
import { Route as contentAdultsExercisessharedPainfulMemoriesIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/painful-memories/index'
import { Route as contentAdultsExercisessharedOneToFiveIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/one-to-five/index'
import { Route as contentAdultsExercisessharedNeurogenicTremoringIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/neurogenic-tremoring/index'
import { Route as contentAdultsExercisessharedInnerGardenIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/inner-garden/index'
import { Route as contentAdultsExercisessharedImaginationIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/imagination/index'
import { Route as contentAdultsExercisessharedGuidedRelaxationIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/guided-relaxation/index'
import { Route as contentAdultsExercisessharedFingerBreathingIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/finger-breathing/index'
import { Route as contentAdultsExercisessharedEftIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/eft/index'
import { Route as contentAdultsExercisessharedDrawingIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/drawing/index'
import { Route as contentAdultsExercisessharedDiaryAdultsIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/diary-adults/index'
import { Route as contentAdultsExercisessharedConversingTogetherIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/conversing-together/index'
import { Route as contentAdultsExercisessharedButterflyHugIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/butterfly-hug/index'
import { Route as contentAdultsExercisessharedBodyExerciseIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/body-exercise/index'
import { Route as contentAdultsExercisessharedBaggageIndexRouteImport } from './routes/(content)/adults/exercises/(shared)/baggage/index'
import { Route as contentChildrenExercisessharedSocialNetworkExerciseRouteImport } from './routes/(content)/children/exercises/(shared)/social-network/exercise'
import { Route as contentChildrenExercisessharedPersonalSourcesSessionsRouteImport } from './routes/(content)/children/exercises/(shared)/personal-sources/sessions'
import { Route as contentChildrenExercisessharedPersonalSourcesEndRouteImport } from './routes/(content)/children/exercises/(shared)/personal-sources/end'
import { Route as contentChildrenExercisessharedPersonalSourcesStepRouteImport } from './routes/(content)/children/exercises/(shared)/personal-sources/$step'
import { Route as contentChildrenExercisessharedHappyPlaceDrawingBoardRouteImport } from './routes/(content)/children/exercises/(shared)/happy-place/drawing-board'
import { Route as contentChildrenExercisessharedHappyPlaceDrawSummaryRouteImport } from './routes/(content)/children/exercises/(shared)/happy-place/draw-summary'
import { Route as contentChildrenExercisessharedDiaryChildrenExerciseRouteImport } from './routes/(content)/children/exercises/(shared)/diary-children/exercise'
import { Route as contentChildrenExercisessharedDiaryChildrenCompletionViewRouteImport } from './routes/(content)/children/exercises/(shared)/diary-children/completionView'
import { Route as contentChildrenExercisessharedDiaryChildrenArchiveRouteImport } from './routes/(content)/children/exercises/(shared)/diary-children/archive'
import { Route as contentAdultsExercisessharedSocialNetworkExerciseRouteImport } from './routes/(content)/adults/exercises/(shared)/social-network/exercise'
import { Route as contentAdultsExercisessharedPositiveImagerySessionRouteImport } from './routes/(content)/adults/exercises/(shared)/positive-imagery/session'
import { Route as contentAdultsExercisessharedPositiveImageryExerciseRouteImport } from './routes/(content)/adults/exercises/(shared)/positive-imagery/exercise'
import { Route as contentAdultsExercisessharedPositiveImageryArchiveRouteImport } from './routes/(content)/adults/exercises/(shared)/positive-imagery/archive'
import { Route as contentAdultsExercisessharedPersonalSourcesSessionsRouteImport } from './routes/(content)/adults/exercises/(shared)/personal-sources/sessions'
import { Route as contentAdultsExercisessharedPersonalSourcesEndRouteImport } from './routes/(content)/adults/exercises/(shared)/personal-sources/end'
import { Route as contentAdultsExercisessharedPersonalSourcesStepRouteImport } from './routes/(content)/adults/exercises/(shared)/personal-sources/$step'
import { Route as contentAdultsExercisessharedImaginationExerciseRouteImport } from './routes/(content)/adults/exercises/(shared)/imagination/exercise'
import { Route as contentAdultsExercisessharedDrawingSummaryRouteImport } from './routes/(content)/adults/exercises/(shared)/drawing/summary'
import { Route as contentAdultsExercisessharedDrawingMandalaRouteImport } from './routes/(content)/adults/exercises/(shared)/drawing/mandala'
import { Route as contentAdultsExercisessharedDiaryAdultsExerciseExplanationRouteImport } from './routes/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation'
import { Route as contentAdultsExercisessharedDiaryAdultsExerciseRouteImport } from './routes/(content)/adults/exercises/(shared)/diary-adults/exercise'
import { Route as contentAdultsExercisessharedDiaryAdultsDiaryTemplateRouteImport } from './routes/(content)/adults/exercises/(shared)/diary-adults/diary-template'
import { Route as contentAdultsExercisessharedDiaryAdultsArchiveRouteImport } from './routes/(content)/adults/exercises/(shared)/diary-adults/archive'
import { Route as contentAdultsExercisessharedConversingTogetherExerciseRouteImport } from './routes/(content)/adults/exercises/(shared)/conversing-together/exercise'
import { Route as contentAdultsExercisessharedConversingTogetherArchiveRouteImport } from './routes/(content)/adults/exercises/(shared)/conversing-together/archive'
import { Route as contentChildrenExercisessharedPersonalSourcesSummarySessionIdRouteImport } from './routes/(content)/children/exercises/(shared)/personal-sources/summary.$sessionId'
import { Route as contentAdultsExercisessharedPersonalSourcesSummarySessionIdRouteImport } from './routes/(content)/adults/exercises/(shared)/personal-sources/summary.$sessionId'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PathRoute = PathRouteImport.update({
  id: '/path',
  path: '/path',
  getParentRoute: () => rootRouteImport,
} as any)
const IntroductionRoute = IntroductionRouteImport.update({
  id: '/introduction',
  path: '/introduction',
  getParentRoute: () => rootRouteImport,
} as any)
const AudienceRoute = AudienceRouteImport.update({
  id: '/audience',
  path: '/audience',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainerRouteRoute = TrainerRouteRouteImport.update({
  id: '/trainer',
  path: '/trainer',
  getParentRoute: () => rootRouteImport,
} as any)
const contentRouteRoute = contentRouteRouteImport.update({
  id: '/(content)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainerProfileRoute = TrainerProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const contentProfileRoute = contentProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => contentRouteRoute,
} as any)
const contentGetHelpRoute = contentGetHelpRouteImport.update({
  id: '/get-help',
  path: '/get-help',
  getParentRoute: () => contentRouteRoute,
} as any)
const contentStudyRouteRoute = contentStudyRouteRouteImport.update({
  id: '/study',
  path: '/study',
  getParentRoute: () => contentRouteRoute,
} as any)
const contentChildrenRouteRoute = contentChildrenRouteRouteImport.update({
  id: '/children',
  path: '/children',
  getParentRoute: () => contentRouteRoute,
} as any)
const contentAdultsRouteRoute = contentAdultsRouteRouteImport.update({
  id: '/adults',
  path: '/adults',
  getParentRoute: () => contentRouteRoute,
} as any)
const TrainerNotesIndexRoute = TrainerNotesIndexRouteImport.update({
  id: '/notes/',
  path: '/notes/',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const TrainerCoursesIndexRoute = TrainerCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const TrainerAuthIndexRoute = TrainerAuthIndexRouteImport.update({
  id: '/auth/',
  path: '/auth/',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const contentStudyIndexRoute = contentStudyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => contentStudyRouteRoute,
} as any)
const TrainerNotesCourseSlugRoute = TrainerNotesCourseSlugRouteImport.update({
  id: '/notes/$courseSlug',
  path: '/notes/$courseSlug',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const TrainerAuthRegisterRoute = TrainerAuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const TrainerAuthLoginRoute = TrainerAuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => TrainerRouteRoute,
} as any)
const contentStudyDoneRoute = contentStudyDoneRouteImport.update({
  id: '/done',
  path: '/done',
  getParentRoute: () => contentStudyRouteRoute,
} as any)
const contentStudyWaveRoute = contentStudyWaveRouteImport.update({
  id: '/$wave',
  path: '/$wave',
  getParentRoute: () => contentStudyRouteRoute,
} as any)
const TrainerCoursesCourseSlugIndexRoute =
  TrainerCoursesCourseSlugIndexRouteImport.update({
    id: '/courses/$courseSlug/',
    path: '/courses/$courseSlug/',
    getParentRoute: () => TrainerRouteRoute,
  } as any)
const contentChildrenSessionIndexRoute =
  contentChildrenSessionIndexRouteImport.update({
    id: '/session/',
    path: '/session/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisesIndexRoute =
  contentChildrenExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentAdultsExercisesIndexRoute =
  contentAdultsExercisesIndexRouteImport.update({
    id: '/exercises/',
    path: '/exercises/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const TrainerCoursesCourseSlugPlayerRoute =
  TrainerCoursesCourseSlugPlayerRouteImport.update({
    id: '/courses/$courseSlug/player',
    path: '/courses/$courseSlug/player',
    getParentRoute: () => TrainerRouteRoute,
  } as any)
const contentAdultsExercisesTraumaIndexRoute =
  contentAdultsExercisesTraumaIndexRouteImport.update({
    id: '/exercises/trauma/',
    path: '/exercises/trauma/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesSuicideIdeationIndexRoute =
  contentAdultsExercisesSuicideIdeationIndexRouteImport.update({
    id: '/exercises/suicide-ideation/',
    path: '/exercises/suicide-ideation/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesSubstanceUseIndexRoute =
  contentAdultsExercisesSubstanceUseIndexRouteImport.update({
    id: '/exercises/substance-use/',
    path: '/exercises/substance-use/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesSleepIndexRoute =
  contentAdultsExercisesSleepIndexRouteImport.update({
    id: '/exercises/sleep/',
    path: '/exercises/sleep/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesSelfInflictedInjuriesIndexRoute =
  contentAdultsExercisesSelfInflictedInjuriesIndexRouteImport.update({
    id: '/exercises/self-inflicted-injuries/',
    path: '/exercises/self-inflicted-injuries/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesPhysicalPainIndexRoute =
  contentAdultsExercisesPhysicalPainIndexRouteImport.update({
    id: '/exercises/physical-pain/',
    path: '/exercises/physical-pain/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesNightmaresIndexRoute =
  contentAdultsExercisesNightmaresIndexRouteImport.update({
    id: '/exercises/nightmares/',
    path: '/exercises/nightmares/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesGuiltFeelingsIndexRoute =
  contentAdultsExercisesGuiltFeelingsIndexRouteImport.update({
    id: '/exercises/guilt-feelings/',
    path: '/exercises/guilt-feelings/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesFlashbacksIndexRoute =
  contentAdultsExercisesFlashbacksIndexRouteImport.update({
    id: '/exercises/flashbacks/',
    path: '/exercises/flashbacks/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesDepressionIndexRoute =
  contentAdultsExercisesDepressionIndexRouteImport.update({
    id: '/exercises/depression/',
    path: '/exercises/depression/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesConcentrationIndexRoute =
  contentAdultsExercisesConcentrationIndexRouteImport.update({
    id: '/exercises/concentration/',
    path: '/exercises/concentration/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesAnxietyIndexRoute =
  contentAdultsExercisesAnxietyIndexRouteImport.update({
    id: '/exercises/anxiety/',
    path: '/exercises/anxiety/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisesAngerIndexRoute =
  contentAdultsExercisesAngerIndexRouteImport.update({
    id: '/exercises/anger/',
    path: '/exercises/anger/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentChildrenExercisessharedTreeOfLifeIndexRoute =
  contentChildrenExercisessharedTreeOfLifeIndexRouteImport.update({
    id: '/exercises/(shared)/tree-of-life/',
    path: '/exercises/tree-of-life/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedStrengthsMapIndexRoute =
  contentChildrenExercisessharedStrengthsMapIndexRouteImport.update({
    id: '/exercises/(shared)/strengths-map/',
    path: '/exercises/strengths-map/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedSocialNetworkIndexRoute =
  contentChildrenExercisessharedSocialNetworkIndexRouteImport.update({
    id: '/exercises/(shared)/social-network/',
    path: '/exercises/social-network/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedRelaxationIndexRoute =
  contentChildrenExercisessharedRelaxationIndexRouteImport.update({
    id: '/exercises/(shared)/relaxation/',
    path: '/exercises/relaxation/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedPersonalSourcesIndexRoute =
  contentChildrenExercisessharedPersonalSourcesIndexRouteImport.update({
    id: '/exercises/(shared)/personal-sources/',
    path: '/exercises/personal-sources/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedMyBraveStoryIndexRoute =
  contentChildrenExercisessharedMyBraveStoryIndexRouteImport.update({
    id: '/exercises/(shared)/my-brave-story/',
    path: '/exercises/my-brave-story/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedHummingBeeBreathIndexRoute =
  contentChildrenExercisessharedHummingBeeBreathIndexRouteImport.update({
    id: '/exercises/(shared)/humming-bee-breath/',
    path: '/exercises/humming-bee-breath/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedHappyPlaceIndexRoute =
  contentChildrenExercisessharedHappyPlaceIndexRouteImport.update({
    id: '/exercises/(shared)/happy-place/',
    path: '/exercises/happy-place/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedGuidedRelaxationIndexRoute =
  contentChildrenExercisessharedGuidedRelaxationIndexRouteImport.update({
    id: '/exercises/(shared)/guided-relaxation/',
    path: '/exercises/guided-relaxation/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedGroundingWalkIndexRoute =
  contentChildrenExercisessharedGroundingWalkIndexRouteImport.update({
    id: '/exercises/(shared)/grounding-walk/',
    path: '/exercises/grounding-walk/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedFingerBreathingIndexRoute =
  contentChildrenExercisessharedFingerBreathingIndexRouteImport.update({
    id: '/exercises/(shared)/finger-breathing/',
    path: '/exercises/finger-breathing/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedDiaryChildrenIndexRoute =
  contentChildrenExercisessharedDiaryChildrenIndexRouteImport.update({
    id: '/exercises/(shared)/diary-children/',
    path: '/exercises/diary-children/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedCircleOfControlIndexRoute =
  contentChildrenExercisessharedCircleOfControlIndexRouteImport.update({
    id: '/exercises/(shared)/circle-of-control/',
    path: '/exercises/circle-of-control/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedBodyExerciseIndexRoute =
  contentChildrenExercisessharedBodyExerciseIndexRouteImport.update({
    id: '/exercises/(shared)/body-exercise/',
    path: '/exercises/body-exercise/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedAngerIcebergIndexRoute =
  contentChildrenExercisessharedAngerIcebergIndexRouteImport.update({
    id: '/exercises/(shared)/anger-iceberg/',
    path: '/exercises/anger-iceberg/',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentAdultsExercisessharedWaterfallIndexRoute =
  contentAdultsExercisessharedWaterfallIndexRouteImport.update({
    id: '/exercises/(shared)/waterfall/',
    path: '/exercises/waterfall/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedTreeOfLifeIndexRoute =
  contentAdultsExercisessharedTreeOfLifeIndexRouteImport.update({
    id: '/exercises/(shared)/tree-of-life/',
    path: '/exercises/tree-of-life/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedThreeBreathIndexRoute =
  contentAdultsExercisessharedThreeBreathIndexRouteImport.update({
    id: '/exercises/(shared)/three-breath/',
    path: '/exercises/three-breath/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedSocialNetworkIndexRoute =
  contentAdultsExercisessharedSocialNetworkIndexRouteImport.update({
    id: '/exercises/(shared)/social-network/',
    path: '/exercises/social-network/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedRelaxationIndexRoute =
  contentAdultsExercisessharedRelaxationIndexRouteImport.update({
    id: '/exercises/(shared)/relaxation/',
    path: '/exercises/relaxation/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPositiveImageryIndexRoute =
  contentAdultsExercisessharedPositiveImageryIndexRouteImport.update({
    id: '/exercises/(shared)/positive-imagery/',
    path: '/exercises/positive-imagery/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPleasantMemoriesIndexRoute =
  contentAdultsExercisessharedPleasantMemoriesIndexRouteImport.update({
    id: '/exercises/(shared)/pleasant-memories/',
    path: '/exercises/pleasant-memories/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPersonalSourcesIndexRoute =
  contentAdultsExercisessharedPersonalSourcesIndexRouteImport.update({
    id: '/exercises/(shared)/personal-sources/',
    path: '/exercises/personal-sources/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPainfulMemoriesIndexRoute =
  contentAdultsExercisessharedPainfulMemoriesIndexRouteImport.update({
    id: '/exercises/(shared)/painful-memories/',
    path: '/exercises/painful-memories/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedOneToFiveIndexRoute =
  contentAdultsExercisessharedOneToFiveIndexRouteImport.update({
    id: '/exercises/(shared)/one-to-five/',
    path: '/exercises/one-to-five/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedNeurogenicTremoringIndexRoute =
  contentAdultsExercisessharedNeurogenicTremoringIndexRouteImport.update({
    id: '/exercises/(shared)/neurogenic-tremoring/',
    path: '/exercises/neurogenic-tremoring/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedInnerGardenIndexRoute =
  contentAdultsExercisessharedInnerGardenIndexRouteImport.update({
    id: '/exercises/(shared)/inner-garden/',
    path: '/exercises/inner-garden/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedImaginationIndexRoute =
  contentAdultsExercisessharedImaginationIndexRouteImport.update({
    id: '/exercises/(shared)/imagination/',
    path: '/exercises/imagination/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedGuidedRelaxationIndexRoute =
  contentAdultsExercisessharedGuidedRelaxationIndexRouteImport.update({
    id: '/exercises/(shared)/guided-relaxation/',
    path: '/exercises/guided-relaxation/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedFingerBreathingIndexRoute =
  contentAdultsExercisessharedFingerBreathingIndexRouteImport.update({
    id: '/exercises/(shared)/finger-breathing/',
    path: '/exercises/finger-breathing/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedEftIndexRoute =
  contentAdultsExercisessharedEftIndexRouteImport.update({
    id: '/exercises/(shared)/eft/',
    path: '/exercises/eft/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDrawingIndexRoute =
  contentAdultsExercisessharedDrawingIndexRouteImport.update({
    id: '/exercises/(shared)/drawing/',
    path: '/exercises/drawing/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDiaryAdultsIndexRoute =
  contentAdultsExercisessharedDiaryAdultsIndexRouteImport.update({
    id: '/exercises/(shared)/diary-adults/',
    path: '/exercises/diary-adults/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedConversingTogetherIndexRoute =
  contentAdultsExercisessharedConversingTogetherIndexRouteImport.update({
    id: '/exercises/(shared)/conversing-together/',
    path: '/exercises/conversing-together/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedButterflyHugIndexRoute =
  contentAdultsExercisessharedButterflyHugIndexRouteImport.update({
    id: '/exercises/(shared)/butterfly-hug/',
    path: '/exercises/butterfly-hug/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedBodyExerciseIndexRoute =
  contentAdultsExercisessharedBodyExerciseIndexRouteImport.update({
    id: '/exercises/(shared)/body-exercise/',
    path: '/exercises/body-exercise/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedBaggageIndexRoute =
  contentAdultsExercisessharedBaggageIndexRouteImport.update({
    id: '/exercises/(shared)/baggage/',
    path: '/exercises/baggage/',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentChildrenExercisessharedSocialNetworkExerciseRoute =
  contentChildrenExercisessharedSocialNetworkExerciseRouteImport.update({
    id: '/exercises/(shared)/social-network/exercise',
    path: '/exercises/social-network/exercise',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedPersonalSourcesSessionsRoute =
  contentChildrenExercisessharedPersonalSourcesSessionsRouteImport.update({
    id: '/exercises/(shared)/personal-sources/sessions',
    path: '/exercises/personal-sources/sessions',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedPersonalSourcesEndRoute =
  contentChildrenExercisessharedPersonalSourcesEndRouteImport.update({
    id: '/exercises/(shared)/personal-sources/end',
    path: '/exercises/personal-sources/end',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedPersonalSourcesStepRoute =
  contentChildrenExercisessharedPersonalSourcesStepRouteImport.update({
    id: '/exercises/(shared)/personal-sources/$step',
    path: '/exercises/personal-sources/$step',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedHappyPlaceDrawingBoardRoute =
  contentChildrenExercisessharedHappyPlaceDrawingBoardRouteImport.update({
    id: '/exercises/(shared)/happy-place/drawing-board',
    path: '/exercises/happy-place/drawing-board',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedHappyPlaceDrawSummaryRoute =
  contentChildrenExercisessharedHappyPlaceDrawSummaryRouteImport.update({
    id: '/exercises/(shared)/happy-place/draw-summary',
    path: '/exercises/happy-place/draw-summary',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedDiaryChildrenExerciseRoute =
  contentChildrenExercisessharedDiaryChildrenExerciseRouteImport.update({
    id: '/exercises/(shared)/diary-children/exercise',
    path: '/exercises/diary-children/exercise',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedDiaryChildrenCompletionViewRoute =
  contentChildrenExercisessharedDiaryChildrenCompletionViewRouteImport.update({
    id: '/exercises/(shared)/diary-children/completionView',
    path: '/exercises/diary-children/completionView',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentChildrenExercisessharedDiaryChildrenArchiveRoute =
  contentChildrenExercisessharedDiaryChildrenArchiveRouteImport.update({
    id: '/exercises/(shared)/diary-children/archive',
    path: '/exercises/diary-children/archive',
    getParentRoute: () => contentChildrenRouteRoute,
  } as any)
const contentAdultsExercisessharedSocialNetworkExerciseRoute =
  contentAdultsExercisessharedSocialNetworkExerciseRouteImport.update({
    id: '/exercises/(shared)/social-network/exercise',
    path: '/exercises/social-network/exercise',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPositiveImagerySessionRoute =
  contentAdultsExercisessharedPositiveImagerySessionRouteImport.update({
    id: '/exercises/(shared)/positive-imagery/session',
    path: '/exercises/positive-imagery/session',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPositiveImageryExerciseRoute =
  contentAdultsExercisessharedPositiveImageryExerciseRouteImport.update({
    id: '/exercises/(shared)/positive-imagery/exercise',
    path: '/exercises/positive-imagery/exercise',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPositiveImageryArchiveRoute =
  contentAdultsExercisessharedPositiveImageryArchiveRouteImport.update({
    id: '/exercises/(shared)/positive-imagery/archive',
    path: '/exercises/positive-imagery/archive',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPersonalSourcesSessionsRoute =
  contentAdultsExercisessharedPersonalSourcesSessionsRouteImport.update({
    id: '/exercises/(shared)/personal-sources/sessions',
    path: '/exercises/personal-sources/sessions',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPersonalSourcesEndRoute =
  contentAdultsExercisessharedPersonalSourcesEndRouteImport.update({
    id: '/exercises/(shared)/personal-sources/end',
    path: '/exercises/personal-sources/end',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedPersonalSourcesStepRoute =
  contentAdultsExercisessharedPersonalSourcesStepRouteImport.update({
    id: '/exercises/(shared)/personal-sources/$step',
    path: '/exercises/personal-sources/$step',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedImaginationExerciseRoute =
  contentAdultsExercisessharedImaginationExerciseRouteImport.update({
    id: '/exercises/(shared)/imagination/exercise',
    path: '/exercises/imagination/exercise',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDrawingSummaryRoute =
  contentAdultsExercisessharedDrawingSummaryRouteImport.update({
    id: '/exercises/(shared)/drawing/summary',
    path: '/exercises/drawing/summary',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDrawingMandalaRoute =
  contentAdultsExercisessharedDrawingMandalaRouteImport.update({
    id: '/exercises/(shared)/drawing/mandala',
    path: '/exercises/drawing/mandala',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute =
  contentAdultsExercisessharedDiaryAdultsExerciseExplanationRouteImport.update({
    id: '/exercises/(shared)/diary-adults/exercise-explanation',
    path: '/exercises/diary-adults/exercise-explanation',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDiaryAdultsExerciseRoute =
  contentAdultsExercisessharedDiaryAdultsExerciseRouteImport.update({
    id: '/exercises/(shared)/diary-adults/exercise',
    path: '/exercises/diary-adults/exercise',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute =
  contentAdultsExercisessharedDiaryAdultsDiaryTemplateRouteImport.update({
    id: '/exercises/(shared)/diary-adults/diary-template',
    path: '/exercises/diary-adults/diary-template',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedDiaryAdultsArchiveRoute =
  contentAdultsExercisessharedDiaryAdultsArchiveRouteImport.update({
    id: '/exercises/(shared)/diary-adults/archive',
    path: '/exercises/diary-adults/archive',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedConversingTogetherExerciseRoute =
  contentAdultsExercisessharedConversingTogetherExerciseRouteImport.update({
    id: '/exercises/(shared)/conversing-together/exercise',
    path: '/exercises/conversing-together/exercise',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentAdultsExercisessharedConversingTogetherArchiveRoute =
  contentAdultsExercisessharedConversingTogetherArchiveRouteImport.update({
    id: '/exercises/(shared)/conversing-together/archive',
    path: '/exercises/conversing-together/archive',
    getParentRoute: () => contentAdultsRouteRoute,
  } as any)
const contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute =
  contentChildrenExercisessharedPersonalSourcesSummarySessionIdRouteImport.update(
    {
      id: '/exercises/(shared)/personal-sources/summary/$sessionId',
      path: '/exercises/personal-sources/summary/$sessionId',
      getParentRoute: () => contentChildrenRouteRoute,
    } as any,
  )
const contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute =
  contentAdultsExercisessharedPersonalSourcesSummarySessionIdRouteImport.update(
    {
      id: '/exercises/(shared)/personal-sources/summary/$sessionId',
      path: '/exercises/personal-sources/summary/$sessionId',
      getParentRoute: () => contentAdultsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/trainer': typeof TrainerRouteRouteWithChildren
  '/app': typeof AppRoute
  '/audience': typeof AudienceRoute
  '/introduction': typeof IntroductionRoute
  '/path': typeof PathRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/welcome': typeof WelcomeRoute
  '/adults': typeof contentAdultsRouteRouteWithChildren
  '/children': typeof contentChildrenRouteRouteWithChildren
  '/study': typeof contentStudyRouteRouteWithChildren
  '/get-help': typeof contentGetHelpRoute
  '/profile': typeof contentProfileRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/trainer/profile': typeof TrainerProfileRoute
  '/study/$wave': typeof contentStudyWaveRoute
  '/study/done': typeof contentStudyDoneRoute
  '/trainer/auth/login': typeof TrainerAuthLoginRoute
  '/trainer/auth/register': typeof TrainerAuthRegisterRoute
  '/trainer/notes/$courseSlug': typeof TrainerNotesCourseSlugRoute
  '/study/': typeof contentStudyIndexRoute
  '/trainer/auth/': typeof TrainerAuthIndexRoute
  '/trainer/courses/': typeof TrainerCoursesIndexRoute
  '/trainer/notes/': typeof TrainerNotesIndexRoute
  '/trainer/courses/$courseSlug/player': typeof TrainerCoursesCourseSlugPlayerRoute
  '/adults/exercises/': typeof contentAdultsExercisesIndexRoute
  '/children/exercises/': typeof contentChildrenExercisesIndexRoute
  '/children/session/': typeof contentChildrenSessionIndexRoute
  '/trainer/courses/$courseSlug/': typeof TrainerCoursesCourseSlugIndexRoute
  '/adults/exercises/anger/': typeof contentAdultsExercisesAngerIndexRoute
  '/adults/exercises/anxiety/': typeof contentAdultsExercisesAnxietyIndexRoute
  '/adults/exercises/concentration/': typeof contentAdultsExercisesConcentrationIndexRoute
  '/adults/exercises/depression/': typeof contentAdultsExercisesDepressionIndexRoute
  '/adults/exercises/flashbacks/': typeof contentAdultsExercisesFlashbacksIndexRoute
  '/adults/exercises/guilt-feelings/': typeof contentAdultsExercisesGuiltFeelingsIndexRoute
  '/adults/exercises/nightmares/': typeof contentAdultsExercisesNightmaresIndexRoute
  '/adults/exercises/physical-pain/': typeof contentAdultsExercisesPhysicalPainIndexRoute
  '/adults/exercises/self-inflicted-injuries/': typeof contentAdultsExercisesSelfInflictedInjuriesIndexRoute
  '/adults/exercises/sleep/': typeof contentAdultsExercisesSleepIndexRoute
  '/adults/exercises/substance-use/': typeof contentAdultsExercisesSubstanceUseIndexRoute
  '/adults/exercises/suicide-ideation/': typeof contentAdultsExercisesSuicideIdeationIndexRoute
  '/adults/exercises/trauma/': typeof contentAdultsExercisesTraumaIndexRoute
  '/adults/exercises/conversing-together/archive': typeof contentAdultsExercisessharedConversingTogetherArchiveRoute
  '/adults/exercises/conversing-together/exercise': typeof contentAdultsExercisessharedConversingTogetherExerciseRoute
  '/adults/exercises/diary-adults/archive': typeof contentAdultsExercisessharedDiaryAdultsArchiveRoute
  '/adults/exercises/diary-adults/diary-template': typeof contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute
  '/adults/exercises/diary-adults/exercise': typeof contentAdultsExercisessharedDiaryAdultsExerciseRoute
  '/adults/exercises/diary-adults/exercise-explanation': typeof contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute
  '/adults/exercises/drawing/mandala': typeof contentAdultsExercisessharedDrawingMandalaRoute
  '/adults/exercises/drawing/summary': typeof contentAdultsExercisessharedDrawingSummaryRoute
  '/adults/exercises/imagination/exercise': typeof contentAdultsExercisessharedImaginationExerciseRoute
  '/adults/exercises/personal-sources/$step': typeof contentAdultsExercisessharedPersonalSourcesStepRoute
  '/adults/exercises/personal-sources/end': typeof contentAdultsExercisessharedPersonalSourcesEndRoute
  '/adults/exercises/personal-sources/sessions': typeof contentAdultsExercisessharedPersonalSourcesSessionsRoute
  '/adults/exercises/positive-imagery/archive': typeof contentAdultsExercisessharedPositiveImageryArchiveRoute
  '/adults/exercises/positive-imagery/exercise': typeof contentAdultsExercisessharedPositiveImageryExerciseRoute
  '/adults/exercises/positive-imagery/session': typeof contentAdultsExercisessharedPositiveImagerySessionRoute
  '/adults/exercises/social-network/exercise': typeof contentAdultsExercisessharedSocialNetworkExerciseRoute
  '/children/exercises/diary-children/archive': typeof contentChildrenExercisessharedDiaryChildrenArchiveRoute
  '/children/exercises/diary-children/completionView': typeof contentChildrenExercisessharedDiaryChildrenCompletionViewRoute
  '/children/exercises/diary-children/exercise': typeof contentChildrenExercisessharedDiaryChildrenExerciseRoute
  '/children/exercises/happy-place/draw-summary': typeof contentChildrenExercisessharedHappyPlaceDrawSummaryRoute
  '/children/exercises/happy-place/drawing-board': typeof contentChildrenExercisessharedHappyPlaceDrawingBoardRoute
  '/children/exercises/personal-sources/$step': typeof contentChildrenExercisessharedPersonalSourcesStepRoute
  '/children/exercises/personal-sources/end': typeof contentChildrenExercisessharedPersonalSourcesEndRoute
  '/children/exercises/personal-sources/sessions': typeof contentChildrenExercisessharedPersonalSourcesSessionsRoute
  '/children/exercises/social-network/exercise': typeof contentChildrenExercisessharedSocialNetworkExerciseRoute
  '/adults/exercises/baggage/': typeof contentAdultsExercisessharedBaggageIndexRoute
  '/adults/exercises/body-exercise/': typeof contentAdultsExercisessharedBodyExerciseIndexRoute
  '/adults/exercises/butterfly-hug/': typeof contentAdultsExercisessharedButterflyHugIndexRoute
  '/adults/exercises/conversing-together/': typeof contentAdultsExercisessharedConversingTogetherIndexRoute
  '/adults/exercises/diary-adults/': typeof contentAdultsExercisessharedDiaryAdultsIndexRoute
  '/adults/exercises/drawing/': typeof contentAdultsExercisessharedDrawingIndexRoute
  '/adults/exercises/eft/': typeof contentAdultsExercisessharedEftIndexRoute
  '/adults/exercises/finger-breathing/': typeof contentAdultsExercisessharedFingerBreathingIndexRoute
  '/adults/exercises/guided-relaxation/': typeof contentAdultsExercisessharedGuidedRelaxationIndexRoute
  '/adults/exercises/imagination/': typeof contentAdultsExercisessharedImaginationIndexRoute
  '/adults/exercises/inner-garden/': typeof contentAdultsExercisessharedInnerGardenIndexRoute
  '/adults/exercises/neurogenic-tremoring/': typeof contentAdultsExercisessharedNeurogenicTremoringIndexRoute
  '/adults/exercises/one-to-five/': typeof contentAdultsExercisessharedOneToFiveIndexRoute
  '/adults/exercises/painful-memories/': typeof contentAdultsExercisessharedPainfulMemoriesIndexRoute
  '/adults/exercises/personal-sources/': typeof contentAdultsExercisessharedPersonalSourcesIndexRoute
  '/adults/exercises/pleasant-memories/': typeof contentAdultsExercisessharedPleasantMemoriesIndexRoute
  '/adults/exercises/positive-imagery/': typeof contentAdultsExercisessharedPositiveImageryIndexRoute
  '/adults/exercises/relaxation/': typeof contentAdultsExercisessharedRelaxationIndexRoute
  '/adults/exercises/social-network/': typeof contentAdultsExercisessharedSocialNetworkIndexRoute
  '/adults/exercises/three-breath/': typeof contentAdultsExercisessharedThreeBreathIndexRoute
  '/adults/exercises/tree-of-life/': typeof contentAdultsExercisessharedTreeOfLifeIndexRoute
  '/adults/exercises/waterfall/': typeof contentAdultsExercisessharedWaterfallIndexRoute
  '/children/exercises/anger-iceberg/': typeof contentChildrenExercisessharedAngerIcebergIndexRoute
  '/children/exercises/body-exercise/': typeof contentChildrenExercisessharedBodyExerciseIndexRoute
  '/children/exercises/circle-of-control/': typeof contentChildrenExercisessharedCircleOfControlIndexRoute
  '/children/exercises/diary-children/': typeof contentChildrenExercisessharedDiaryChildrenIndexRoute
  '/children/exercises/finger-breathing/': typeof contentChildrenExercisessharedFingerBreathingIndexRoute
  '/children/exercises/grounding-walk/': typeof contentChildrenExercisessharedGroundingWalkIndexRoute
  '/children/exercises/guided-relaxation/': typeof contentChildrenExercisessharedGuidedRelaxationIndexRoute
  '/children/exercises/happy-place/': typeof contentChildrenExercisessharedHappyPlaceIndexRoute
  '/children/exercises/humming-bee-breath/': typeof contentChildrenExercisessharedHummingBeeBreathIndexRoute
  '/children/exercises/my-brave-story/': typeof contentChildrenExercisessharedMyBraveStoryIndexRoute
  '/children/exercises/personal-sources/': typeof contentChildrenExercisessharedPersonalSourcesIndexRoute
  '/children/exercises/relaxation/': typeof contentChildrenExercisessharedRelaxationIndexRoute
  '/children/exercises/social-network/': typeof contentChildrenExercisessharedSocialNetworkIndexRoute
  '/children/exercises/strengths-map/': typeof contentChildrenExercisessharedStrengthsMapIndexRoute
  '/children/exercises/tree-of-life/': typeof contentChildrenExercisessharedTreeOfLifeIndexRoute
  '/adults/exercises/personal-sources/summary/$sessionId': typeof contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute
  '/children/exercises/personal-sources/summary/$sessionId': typeof contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/trainer': typeof TrainerRouteRouteWithChildren
  '/app': typeof AppRoute
  '/audience': typeof AudienceRoute
  '/introduction': typeof IntroductionRoute
  '/path': typeof PathRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/welcome': typeof WelcomeRoute
  '/adults': typeof contentAdultsRouteRouteWithChildren
  '/children': typeof contentChildrenRouteRouteWithChildren
  '/get-help': typeof contentGetHelpRoute
  '/profile': typeof contentProfileRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/trainer/profile': typeof TrainerProfileRoute
  '/study/$wave': typeof contentStudyWaveRoute
  '/study/done': typeof contentStudyDoneRoute
  '/trainer/auth/login': typeof TrainerAuthLoginRoute
  '/trainer/auth/register': typeof TrainerAuthRegisterRoute
  '/trainer/notes/$courseSlug': typeof TrainerNotesCourseSlugRoute
  '/study': typeof contentStudyIndexRoute
  '/trainer/auth': typeof TrainerAuthIndexRoute
  '/trainer/courses': typeof TrainerCoursesIndexRoute
  '/trainer/notes': typeof TrainerNotesIndexRoute
  '/trainer/courses/$courseSlug/player': typeof TrainerCoursesCourseSlugPlayerRoute
  '/adults/exercises': typeof contentAdultsExercisesIndexRoute
  '/children/exercises': typeof contentChildrenExercisesIndexRoute
  '/children/session': typeof contentChildrenSessionIndexRoute
  '/trainer/courses/$courseSlug': typeof TrainerCoursesCourseSlugIndexRoute
  '/adults/exercises/anger': typeof contentAdultsExercisesAngerIndexRoute
  '/adults/exercises/anxiety': typeof contentAdultsExercisesAnxietyIndexRoute
  '/adults/exercises/concentration': typeof contentAdultsExercisesConcentrationIndexRoute
  '/adults/exercises/depression': typeof contentAdultsExercisesDepressionIndexRoute
  '/adults/exercises/flashbacks': typeof contentAdultsExercisesFlashbacksIndexRoute
  '/adults/exercises/guilt-feelings': typeof contentAdultsExercisesGuiltFeelingsIndexRoute
  '/adults/exercises/nightmares': typeof contentAdultsExercisesNightmaresIndexRoute
  '/adults/exercises/physical-pain': typeof contentAdultsExercisesPhysicalPainIndexRoute
  '/adults/exercises/self-inflicted-injuries': typeof contentAdultsExercisesSelfInflictedInjuriesIndexRoute
  '/adults/exercises/sleep': typeof contentAdultsExercisesSleepIndexRoute
  '/adults/exercises/substance-use': typeof contentAdultsExercisesSubstanceUseIndexRoute
  '/adults/exercises/suicide-ideation': typeof contentAdultsExercisesSuicideIdeationIndexRoute
  '/adults/exercises/trauma': typeof contentAdultsExercisesTraumaIndexRoute
  '/adults/exercises/conversing-together/archive': typeof contentAdultsExercisessharedConversingTogetherArchiveRoute
  '/adults/exercises/conversing-together/exercise': typeof contentAdultsExercisessharedConversingTogetherExerciseRoute
  '/adults/exercises/diary-adults/archive': typeof contentAdultsExercisessharedDiaryAdultsArchiveRoute
  '/adults/exercises/diary-adults/diary-template': typeof contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute
  '/adults/exercises/diary-adults/exercise': typeof contentAdultsExercisessharedDiaryAdultsExerciseRoute
  '/adults/exercises/diary-adults/exercise-explanation': typeof contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute
  '/adults/exercises/drawing/mandala': typeof contentAdultsExercisessharedDrawingMandalaRoute
  '/adults/exercises/drawing/summary': typeof contentAdultsExercisessharedDrawingSummaryRoute
  '/adults/exercises/imagination/exercise': typeof contentAdultsExercisessharedImaginationExerciseRoute
  '/adults/exercises/personal-sources/$step': typeof contentAdultsExercisessharedPersonalSourcesStepRoute
  '/adults/exercises/personal-sources/end': typeof contentAdultsExercisessharedPersonalSourcesEndRoute
  '/adults/exercises/personal-sources/sessions': typeof contentAdultsExercisessharedPersonalSourcesSessionsRoute
  '/adults/exercises/positive-imagery/archive': typeof contentAdultsExercisessharedPositiveImageryArchiveRoute
  '/adults/exercises/positive-imagery/exercise': typeof contentAdultsExercisessharedPositiveImageryExerciseRoute
  '/adults/exercises/positive-imagery/session': typeof contentAdultsExercisessharedPositiveImagerySessionRoute
  '/adults/exercises/social-network/exercise': typeof contentAdultsExercisessharedSocialNetworkExerciseRoute
  '/children/exercises/diary-children/archive': typeof contentChildrenExercisessharedDiaryChildrenArchiveRoute
  '/children/exercises/diary-children/completionView': typeof contentChildrenExercisessharedDiaryChildrenCompletionViewRoute
  '/children/exercises/diary-children/exercise': typeof contentChildrenExercisessharedDiaryChildrenExerciseRoute
  '/children/exercises/happy-place/draw-summary': typeof contentChildrenExercisessharedHappyPlaceDrawSummaryRoute
  '/children/exercises/happy-place/drawing-board': typeof contentChildrenExercisessharedHappyPlaceDrawingBoardRoute
  '/children/exercises/personal-sources/$step': typeof contentChildrenExercisessharedPersonalSourcesStepRoute
  '/children/exercises/personal-sources/end': typeof contentChildrenExercisessharedPersonalSourcesEndRoute
  '/children/exercises/personal-sources/sessions': typeof contentChildrenExercisessharedPersonalSourcesSessionsRoute
  '/children/exercises/social-network/exercise': typeof contentChildrenExercisessharedSocialNetworkExerciseRoute
  '/adults/exercises/baggage': typeof contentAdultsExercisessharedBaggageIndexRoute
  '/adults/exercises/body-exercise': typeof contentAdultsExercisessharedBodyExerciseIndexRoute
  '/adults/exercises/butterfly-hug': typeof contentAdultsExercisessharedButterflyHugIndexRoute
  '/adults/exercises/conversing-together': typeof contentAdultsExercisessharedConversingTogetherIndexRoute
  '/adults/exercises/diary-adults': typeof contentAdultsExercisessharedDiaryAdultsIndexRoute
  '/adults/exercises/drawing': typeof contentAdultsExercisessharedDrawingIndexRoute
  '/adults/exercises/eft': typeof contentAdultsExercisessharedEftIndexRoute
  '/adults/exercises/finger-breathing': typeof contentAdultsExercisessharedFingerBreathingIndexRoute
  '/adults/exercises/guided-relaxation': typeof contentAdultsExercisessharedGuidedRelaxationIndexRoute
  '/adults/exercises/imagination': typeof contentAdultsExercisessharedImaginationIndexRoute
  '/adults/exercises/inner-garden': typeof contentAdultsExercisessharedInnerGardenIndexRoute
  '/adults/exercises/neurogenic-tremoring': typeof contentAdultsExercisessharedNeurogenicTremoringIndexRoute
  '/adults/exercises/one-to-five': typeof contentAdultsExercisessharedOneToFiveIndexRoute
  '/adults/exercises/painful-memories': typeof contentAdultsExercisessharedPainfulMemoriesIndexRoute
  '/adults/exercises/personal-sources': typeof contentAdultsExercisessharedPersonalSourcesIndexRoute
  '/adults/exercises/pleasant-memories': typeof contentAdultsExercisessharedPleasantMemoriesIndexRoute
  '/adults/exercises/positive-imagery': typeof contentAdultsExercisessharedPositiveImageryIndexRoute
  '/adults/exercises/relaxation': typeof contentAdultsExercisessharedRelaxationIndexRoute
  '/adults/exercises/social-network': typeof contentAdultsExercisessharedSocialNetworkIndexRoute
  '/adults/exercises/three-breath': typeof contentAdultsExercisessharedThreeBreathIndexRoute
  '/adults/exercises/tree-of-life': typeof contentAdultsExercisessharedTreeOfLifeIndexRoute
  '/adults/exercises/waterfall': typeof contentAdultsExercisessharedWaterfallIndexRoute
  '/children/exercises/anger-iceberg': typeof contentChildrenExercisessharedAngerIcebergIndexRoute
  '/children/exercises/body-exercise': typeof contentChildrenExercisessharedBodyExerciseIndexRoute
  '/children/exercises/circle-of-control': typeof contentChildrenExercisessharedCircleOfControlIndexRoute
  '/children/exercises/diary-children': typeof contentChildrenExercisessharedDiaryChildrenIndexRoute
  '/children/exercises/finger-breathing': typeof contentChildrenExercisessharedFingerBreathingIndexRoute
  '/children/exercises/grounding-walk': typeof contentChildrenExercisessharedGroundingWalkIndexRoute
  '/children/exercises/guided-relaxation': typeof contentChildrenExercisessharedGuidedRelaxationIndexRoute
  '/children/exercises/happy-place': typeof contentChildrenExercisessharedHappyPlaceIndexRoute
  '/children/exercises/humming-bee-breath': typeof contentChildrenExercisessharedHummingBeeBreathIndexRoute
  '/children/exercises/my-brave-story': typeof contentChildrenExercisessharedMyBraveStoryIndexRoute
  '/children/exercises/personal-sources': typeof contentChildrenExercisessharedPersonalSourcesIndexRoute
  '/children/exercises/relaxation': typeof contentChildrenExercisessharedRelaxationIndexRoute
  '/children/exercises/social-network': typeof contentChildrenExercisessharedSocialNetworkIndexRoute
  '/children/exercises/strengths-map': typeof contentChildrenExercisessharedStrengthsMapIndexRoute
  '/children/exercises/tree-of-life': typeof contentChildrenExercisessharedTreeOfLifeIndexRoute
  '/adults/exercises/personal-sources/summary/$sessionId': typeof contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute
  '/children/exercises/personal-sources/summary/$sessionId': typeof contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(content)': typeof contentRouteRouteWithChildren
  '/trainer': typeof TrainerRouteRouteWithChildren
  '/app': typeof AppRoute
  '/audience': typeof AudienceRoute
  '/introduction': typeof IntroductionRoute
  '/path': typeof PathRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/welcome': typeof WelcomeRoute
  '/(content)/adults': typeof contentAdultsRouteRouteWithChildren
  '/(content)/children': typeof contentChildrenRouteRouteWithChildren
  '/(content)/study': typeof contentStudyRouteRouteWithChildren
  '/(content)/get-help': typeof contentGetHelpRoute
  '/(content)/profile': typeof contentProfileRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/trainer/profile': typeof TrainerProfileRoute
  '/(content)/study/$wave': typeof contentStudyWaveRoute
  '/(content)/study/done': typeof contentStudyDoneRoute
  '/trainer/auth/login': typeof TrainerAuthLoginRoute
  '/trainer/auth/register': typeof TrainerAuthRegisterRoute
  '/trainer/notes/$courseSlug': typeof TrainerNotesCourseSlugRoute
  '/(content)/study/': typeof contentStudyIndexRoute
  '/trainer/auth/': typeof TrainerAuthIndexRoute
  '/trainer/courses/': typeof TrainerCoursesIndexRoute
  '/trainer/notes/': typeof TrainerNotesIndexRoute
  '/trainer/courses/$courseSlug/player': typeof TrainerCoursesCourseSlugPlayerRoute
  '/(content)/adults/exercises/': typeof contentAdultsExercisesIndexRoute
  '/(content)/children/exercises/': typeof contentChildrenExercisesIndexRoute
  '/(content)/children/session/': typeof contentChildrenSessionIndexRoute
  '/trainer/courses/$courseSlug/': typeof TrainerCoursesCourseSlugIndexRoute
  '/(content)/adults/exercises/anger/': typeof contentAdultsExercisesAngerIndexRoute
  '/(content)/adults/exercises/anxiety/': typeof contentAdultsExercisesAnxietyIndexRoute
  '/(content)/adults/exercises/concentration/': typeof contentAdultsExercisesConcentrationIndexRoute
  '/(content)/adults/exercises/depression/': typeof contentAdultsExercisesDepressionIndexRoute
  '/(content)/adults/exercises/flashbacks/': typeof contentAdultsExercisesFlashbacksIndexRoute
  '/(content)/adults/exercises/guilt-feelings/': typeof contentAdultsExercisesGuiltFeelingsIndexRoute
  '/(content)/adults/exercises/nightmares/': typeof contentAdultsExercisesNightmaresIndexRoute
  '/(content)/adults/exercises/physical-pain/': typeof contentAdultsExercisesPhysicalPainIndexRoute
  '/(content)/adults/exercises/self-inflicted-injuries/': typeof contentAdultsExercisesSelfInflictedInjuriesIndexRoute
  '/(content)/adults/exercises/sleep/': typeof contentAdultsExercisesSleepIndexRoute
  '/(content)/adults/exercises/substance-use/': typeof contentAdultsExercisesSubstanceUseIndexRoute
  '/(content)/adults/exercises/suicide-ideation/': typeof contentAdultsExercisesSuicideIdeationIndexRoute
  '/(content)/adults/exercises/trauma/': typeof contentAdultsExercisesTraumaIndexRoute
  '/(content)/adults/exercises/(shared)/conversing-together/archive': typeof contentAdultsExercisessharedConversingTogetherArchiveRoute
  '/(content)/adults/exercises/(shared)/conversing-together/exercise': typeof contentAdultsExercisessharedConversingTogetherExerciseRoute
  '/(content)/adults/exercises/(shared)/diary-adults/archive': typeof contentAdultsExercisessharedDiaryAdultsArchiveRoute
  '/(content)/adults/exercises/(shared)/diary-adults/diary-template': typeof contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute
  '/(content)/adults/exercises/(shared)/diary-adults/exercise': typeof contentAdultsExercisessharedDiaryAdultsExerciseRoute
  '/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation': typeof contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute
  '/(content)/adults/exercises/(shared)/drawing/mandala': typeof contentAdultsExercisessharedDrawingMandalaRoute
  '/(content)/adults/exercises/(shared)/drawing/summary': typeof contentAdultsExercisessharedDrawingSummaryRoute
  '/(content)/adults/exercises/(shared)/imagination/exercise': typeof contentAdultsExercisessharedImaginationExerciseRoute
  '/(content)/adults/exercises/(shared)/personal-sources/$step': typeof contentAdultsExercisessharedPersonalSourcesStepRoute
  '/(content)/adults/exercises/(shared)/personal-sources/end': typeof contentAdultsExercisessharedPersonalSourcesEndRoute
  '/(content)/adults/exercises/(shared)/personal-sources/sessions': typeof contentAdultsExercisessharedPersonalSourcesSessionsRoute
  '/(content)/adults/exercises/(shared)/positive-imagery/archive': typeof contentAdultsExercisessharedPositiveImageryArchiveRoute
  '/(content)/adults/exercises/(shared)/positive-imagery/exercise': typeof contentAdultsExercisessharedPositiveImageryExerciseRoute
  '/(content)/adults/exercises/(shared)/positive-imagery/session': typeof contentAdultsExercisessharedPositiveImagerySessionRoute
  '/(content)/adults/exercises/(shared)/social-network/exercise': typeof contentAdultsExercisessharedSocialNetworkExerciseRoute
  '/(content)/children/exercises/(shared)/diary-children/archive': typeof contentChildrenExercisessharedDiaryChildrenArchiveRoute
  '/(content)/children/exercises/(shared)/diary-children/completionView': typeof contentChildrenExercisessharedDiaryChildrenCompletionViewRoute
  '/(content)/children/exercises/(shared)/diary-children/exercise': typeof contentChildrenExercisessharedDiaryChildrenExerciseRoute
  '/(content)/children/exercises/(shared)/happy-place/draw-summary': typeof contentChildrenExercisessharedHappyPlaceDrawSummaryRoute
  '/(content)/children/exercises/(shared)/happy-place/drawing-board': typeof contentChildrenExercisessharedHappyPlaceDrawingBoardRoute
  '/(content)/children/exercises/(shared)/personal-sources/$step': typeof contentChildrenExercisessharedPersonalSourcesStepRoute
  '/(content)/children/exercises/(shared)/personal-sources/end': typeof contentChildrenExercisessharedPersonalSourcesEndRoute
  '/(content)/children/exercises/(shared)/personal-sources/sessions': typeof contentChildrenExercisessharedPersonalSourcesSessionsRoute
  '/(content)/children/exercises/(shared)/social-network/exercise': typeof contentChildrenExercisessharedSocialNetworkExerciseRoute
  '/(content)/adults/exercises/(shared)/baggage/': typeof contentAdultsExercisessharedBaggageIndexRoute
  '/(content)/adults/exercises/(shared)/body-exercise/': typeof contentAdultsExercisessharedBodyExerciseIndexRoute
  '/(content)/adults/exercises/(shared)/butterfly-hug/': typeof contentAdultsExercisessharedButterflyHugIndexRoute
  '/(content)/adults/exercises/(shared)/conversing-together/': typeof contentAdultsExercisessharedConversingTogetherIndexRoute
  '/(content)/adults/exercises/(shared)/diary-adults/': typeof contentAdultsExercisessharedDiaryAdultsIndexRoute
  '/(content)/adults/exercises/(shared)/drawing/': typeof contentAdultsExercisessharedDrawingIndexRoute
  '/(content)/adults/exercises/(shared)/eft/': typeof contentAdultsExercisessharedEftIndexRoute
  '/(content)/adults/exercises/(shared)/finger-breathing/': typeof contentAdultsExercisessharedFingerBreathingIndexRoute
  '/(content)/adults/exercises/(shared)/guided-relaxation/': typeof contentAdultsExercisessharedGuidedRelaxationIndexRoute
  '/(content)/adults/exercises/(shared)/imagination/': typeof contentAdultsExercisessharedImaginationIndexRoute
  '/(content)/adults/exercises/(shared)/inner-garden/': typeof contentAdultsExercisessharedInnerGardenIndexRoute
  '/(content)/adults/exercises/(shared)/neurogenic-tremoring/': typeof contentAdultsExercisessharedNeurogenicTremoringIndexRoute
  '/(content)/adults/exercises/(shared)/one-to-five/': typeof contentAdultsExercisessharedOneToFiveIndexRoute
  '/(content)/adults/exercises/(shared)/painful-memories/': typeof contentAdultsExercisessharedPainfulMemoriesIndexRoute
  '/(content)/adults/exercises/(shared)/personal-sources/': typeof contentAdultsExercisessharedPersonalSourcesIndexRoute
  '/(content)/adults/exercises/(shared)/pleasant-memories/': typeof contentAdultsExercisessharedPleasantMemoriesIndexRoute
  '/(content)/adults/exercises/(shared)/positive-imagery/': typeof contentAdultsExercisessharedPositiveImageryIndexRoute
  '/(content)/adults/exercises/(shared)/relaxation/': typeof contentAdultsExercisessharedRelaxationIndexRoute
  '/(content)/adults/exercises/(shared)/social-network/': typeof contentAdultsExercisessharedSocialNetworkIndexRoute
  '/(content)/adults/exercises/(shared)/three-breath/': typeof contentAdultsExercisessharedThreeBreathIndexRoute
  '/(content)/adults/exercises/(shared)/tree-of-life/': typeof contentAdultsExercisessharedTreeOfLifeIndexRoute
  '/(content)/adults/exercises/(shared)/waterfall/': typeof contentAdultsExercisessharedWaterfallIndexRoute
  '/(content)/children/exercises/(shared)/anger-iceberg/': typeof contentChildrenExercisessharedAngerIcebergIndexRoute
  '/(content)/children/exercises/(shared)/body-exercise/': typeof contentChildrenExercisessharedBodyExerciseIndexRoute
  '/(content)/children/exercises/(shared)/circle-of-control/': typeof contentChildrenExercisessharedCircleOfControlIndexRoute
  '/(content)/children/exercises/(shared)/diary-children/': typeof contentChildrenExercisessharedDiaryChildrenIndexRoute
  '/(content)/children/exercises/(shared)/finger-breathing/': typeof contentChildrenExercisessharedFingerBreathingIndexRoute
  '/(content)/children/exercises/(shared)/grounding-walk/': typeof contentChildrenExercisessharedGroundingWalkIndexRoute
  '/(content)/children/exercises/(shared)/guided-relaxation/': typeof contentChildrenExercisessharedGuidedRelaxationIndexRoute
  '/(content)/children/exercises/(shared)/happy-place/': typeof contentChildrenExercisessharedHappyPlaceIndexRoute
  '/(content)/children/exercises/(shared)/humming-bee-breath/': typeof contentChildrenExercisessharedHummingBeeBreathIndexRoute
  '/(content)/children/exercises/(shared)/my-brave-story/': typeof contentChildrenExercisessharedMyBraveStoryIndexRoute
  '/(content)/children/exercises/(shared)/personal-sources/': typeof contentChildrenExercisessharedPersonalSourcesIndexRoute
  '/(content)/children/exercises/(shared)/relaxation/': typeof contentChildrenExercisessharedRelaxationIndexRoute
  '/(content)/children/exercises/(shared)/social-network/': typeof contentChildrenExercisessharedSocialNetworkIndexRoute
  '/(content)/children/exercises/(shared)/strengths-map/': typeof contentChildrenExercisessharedStrengthsMapIndexRoute
  '/(content)/children/exercises/(shared)/tree-of-life/': typeof contentChildrenExercisessharedTreeOfLifeIndexRoute
  '/(content)/adults/exercises/(shared)/personal-sources/summary/$sessionId': typeof contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute
  '/(content)/children/exercises/(shared)/personal-sources/summary/$sessionId': typeof contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/trainer'
    | '/app'
    | '/audience'
    | '/introduction'
    | '/path'
    | '/privacy-policy'
    | '/welcome'
    | '/adults'
    | '/children'
    | '/study'
    | '/get-help'
    | '/profile'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/trainer/profile'
    | '/study/$wave'
    | '/study/done'
    | '/trainer/auth/login'
    | '/trainer/auth/register'
    | '/trainer/notes/$courseSlug'
    | '/study/'
    | '/trainer/auth/'
    | '/trainer/courses/'
    | '/trainer/notes/'
    | '/trainer/courses/$courseSlug/player'
    | '/adults/exercises/'
    | '/children/exercises/'
    | '/children/session/'
    | '/trainer/courses/$courseSlug/'
    | '/adults/exercises/anger/'
    | '/adults/exercises/anxiety/'
    | '/adults/exercises/concentration/'
    | '/adults/exercises/depression/'
    | '/adults/exercises/flashbacks/'
    | '/adults/exercises/guilt-feelings/'
    | '/adults/exercises/nightmares/'
    | '/adults/exercises/physical-pain/'
    | '/adults/exercises/self-inflicted-injuries/'
    | '/adults/exercises/sleep/'
    | '/adults/exercises/substance-use/'
    | '/adults/exercises/suicide-ideation/'
    | '/adults/exercises/trauma/'
    | '/adults/exercises/conversing-together/archive'
    | '/adults/exercises/conversing-together/exercise'
    | '/adults/exercises/diary-adults/archive'
    | '/adults/exercises/diary-adults/diary-template'
    | '/adults/exercises/diary-adults/exercise'
    | '/adults/exercises/diary-adults/exercise-explanation'
    | '/adults/exercises/drawing/mandala'
    | '/adults/exercises/drawing/summary'
    | '/adults/exercises/imagination/exercise'
    | '/adults/exercises/personal-sources/$step'
    | '/adults/exercises/personal-sources/end'
    | '/adults/exercises/personal-sources/sessions'
    | '/adults/exercises/positive-imagery/archive'
    | '/adults/exercises/positive-imagery/exercise'
    | '/adults/exercises/positive-imagery/session'
    | '/adults/exercises/social-network/exercise'
    | '/children/exercises/diary-children/archive'
    | '/children/exercises/diary-children/completionView'
    | '/children/exercises/diary-children/exercise'
    | '/children/exercises/happy-place/draw-summary'
    | '/children/exercises/happy-place/drawing-board'
    | '/children/exercises/personal-sources/$step'
    | '/children/exercises/personal-sources/end'
    | '/children/exercises/personal-sources/sessions'
    | '/children/exercises/social-network/exercise'
    | '/adults/exercises/baggage/'
    | '/adults/exercises/body-exercise/'
    | '/adults/exercises/butterfly-hug/'
    | '/adults/exercises/conversing-together/'
    | '/adults/exercises/diary-adults/'
    | '/adults/exercises/drawing/'
    | '/adults/exercises/eft/'
    | '/adults/exercises/finger-breathing/'
    | '/adults/exercises/guided-relaxation/'
    | '/adults/exercises/imagination/'
    | '/adults/exercises/inner-garden/'
    | '/adults/exercises/neurogenic-tremoring/'
    | '/adults/exercises/one-to-five/'
    | '/adults/exercises/painful-memories/'
    | '/adults/exercises/personal-sources/'
    | '/adults/exercises/pleasant-memories/'
    | '/adults/exercises/positive-imagery/'
    | '/adults/exercises/relaxation/'
    | '/adults/exercises/social-network/'
    | '/adults/exercises/three-breath/'
    | '/adults/exercises/tree-of-life/'
    | '/adults/exercises/waterfall/'
    | '/children/exercises/anger-iceberg/'
    | '/children/exercises/body-exercise/'
    | '/children/exercises/circle-of-control/'
    | '/children/exercises/diary-children/'
    | '/children/exercises/finger-breathing/'
    | '/children/exercises/grounding-walk/'
    | '/children/exercises/guided-relaxation/'
    | '/children/exercises/happy-place/'
    | '/children/exercises/humming-bee-breath/'
    | '/children/exercises/my-brave-story/'
    | '/children/exercises/personal-sources/'
    | '/children/exercises/relaxation/'
    | '/children/exercises/social-network/'
    | '/children/exercises/strengths-map/'
    | '/children/exercises/tree-of-life/'
    | '/adults/exercises/personal-sources/summary/$sessionId'
    | '/children/exercises/personal-sources/summary/$sessionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/trainer'
    | '/app'
    | '/audience'
    | '/introduction'
    | '/path'
    | '/privacy-policy'
    | '/welcome'
    | '/adults'
    | '/children'
    | '/get-help'
    | '/profile'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/trainer/profile'
    | '/study/$wave'
    | '/study/done'
    | '/trainer/auth/login'
    | '/trainer/auth/register'
    | '/trainer/notes/$courseSlug'
    | '/study'
    | '/trainer/auth'
    | '/trainer/courses'
    | '/trainer/notes'
    | '/trainer/courses/$courseSlug/player'
    | '/adults/exercises'
    | '/children/exercises'
    | '/children/session'
    | '/trainer/courses/$courseSlug'
    | '/adults/exercises/anger'
    | '/adults/exercises/anxiety'
    | '/adults/exercises/concentration'
    | '/adults/exercises/depression'
    | '/adults/exercises/flashbacks'
    | '/adults/exercises/guilt-feelings'
    | '/adults/exercises/nightmares'
    | '/adults/exercises/physical-pain'
    | '/adults/exercises/self-inflicted-injuries'
    | '/adults/exercises/sleep'
    | '/adults/exercises/substance-use'
    | '/adults/exercises/suicide-ideation'
    | '/adults/exercises/trauma'
    | '/adults/exercises/conversing-together/archive'
    | '/adults/exercises/conversing-together/exercise'
    | '/adults/exercises/diary-adults/archive'
    | '/adults/exercises/diary-adults/diary-template'
    | '/adults/exercises/diary-adults/exercise'
    | '/adults/exercises/diary-adults/exercise-explanation'
    | '/adults/exercises/drawing/mandala'
    | '/adults/exercises/drawing/summary'
    | '/adults/exercises/imagination/exercise'
    | '/adults/exercises/personal-sources/$step'
    | '/adults/exercises/personal-sources/end'
    | '/adults/exercises/personal-sources/sessions'
    | '/adults/exercises/positive-imagery/archive'
    | '/adults/exercises/positive-imagery/exercise'
    | '/adults/exercises/positive-imagery/session'
    | '/adults/exercises/social-network/exercise'
    | '/children/exercises/diary-children/archive'
    | '/children/exercises/diary-children/completionView'
    | '/children/exercises/diary-children/exercise'
    | '/children/exercises/happy-place/draw-summary'
    | '/children/exercises/happy-place/drawing-board'
    | '/children/exercises/personal-sources/$step'
    | '/children/exercises/personal-sources/end'
    | '/children/exercises/personal-sources/sessions'
    | '/children/exercises/social-network/exercise'
    | '/adults/exercises/baggage'
    | '/adults/exercises/body-exercise'
    | '/adults/exercises/butterfly-hug'
    | '/adults/exercises/conversing-together'
    | '/adults/exercises/diary-adults'
    | '/adults/exercises/drawing'
    | '/adults/exercises/eft'
    | '/adults/exercises/finger-breathing'
    | '/adults/exercises/guided-relaxation'
    | '/adults/exercises/imagination'
    | '/adults/exercises/inner-garden'
    | '/adults/exercises/neurogenic-tremoring'
    | '/adults/exercises/one-to-five'
    | '/adults/exercises/painful-memories'
    | '/adults/exercises/personal-sources'
    | '/adults/exercises/pleasant-memories'
    | '/adults/exercises/positive-imagery'
    | '/adults/exercises/relaxation'
    | '/adults/exercises/social-network'
    | '/adults/exercises/three-breath'
    | '/adults/exercises/tree-of-life'
    | '/adults/exercises/waterfall'
    | '/children/exercises/anger-iceberg'
    | '/children/exercises/body-exercise'
    | '/children/exercises/circle-of-control'
    | '/children/exercises/diary-children'
    | '/children/exercises/finger-breathing'
    | '/children/exercises/grounding-walk'
    | '/children/exercises/guided-relaxation'
    | '/children/exercises/happy-place'
    | '/children/exercises/humming-bee-breath'
    | '/children/exercises/my-brave-story'
    | '/children/exercises/personal-sources'
    | '/children/exercises/relaxation'
    | '/children/exercises/social-network'
    | '/children/exercises/strengths-map'
    | '/children/exercises/tree-of-life'
    | '/adults/exercises/personal-sources/summary/$sessionId'
    | '/children/exercises/personal-sources/summary/$sessionId'
  id:
    | '__root__'
    | '/'
    | '/(content)'
    | '/trainer'
    | '/app'
    | '/audience'
    | '/introduction'
    | '/path'
    | '/privacy-policy'
    | '/welcome'
    | '/(content)/adults'
    | '/(content)/children'
    | '/(content)/study'
    | '/(content)/get-help'
    | '/(content)/profile'
    | '/auth/forgot-password'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/trainer/profile'
    | '/(content)/study/$wave'
    | '/(content)/study/done'
    | '/trainer/auth/login'
    | '/trainer/auth/register'
    | '/trainer/notes/$courseSlug'
    | '/(content)/study/'
    | '/trainer/auth/'
    | '/trainer/courses/'
    | '/trainer/notes/'
    | '/trainer/courses/$courseSlug/player'
    | '/(content)/adults/exercises/'
    | '/(content)/children/exercises/'
    | '/(content)/children/session/'
    | '/trainer/courses/$courseSlug/'
    | '/(content)/adults/exercises/anger/'
    | '/(content)/adults/exercises/anxiety/'
    | '/(content)/adults/exercises/concentration/'
    | '/(content)/adults/exercises/depression/'
    | '/(content)/adults/exercises/flashbacks/'
    | '/(content)/adults/exercises/guilt-feelings/'
    | '/(content)/adults/exercises/nightmares/'
    | '/(content)/adults/exercises/physical-pain/'
    | '/(content)/adults/exercises/self-inflicted-injuries/'
    | '/(content)/adults/exercises/sleep/'
    | '/(content)/adults/exercises/substance-use/'
    | '/(content)/adults/exercises/suicide-ideation/'
    | '/(content)/adults/exercises/trauma/'
    | '/(content)/adults/exercises/(shared)/conversing-together/archive'
    | '/(content)/adults/exercises/(shared)/conversing-together/exercise'
    | '/(content)/adults/exercises/(shared)/diary-adults/archive'
    | '/(content)/adults/exercises/(shared)/diary-adults/diary-template'
    | '/(content)/adults/exercises/(shared)/diary-adults/exercise'
    | '/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation'
    | '/(content)/adults/exercises/(shared)/drawing/mandala'
    | '/(content)/adults/exercises/(shared)/drawing/summary'
    | '/(content)/adults/exercises/(shared)/imagination/exercise'
    | '/(content)/adults/exercises/(shared)/personal-sources/$step'
    | '/(content)/adults/exercises/(shared)/personal-sources/end'
    | '/(content)/adults/exercises/(shared)/personal-sources/sessions'
    | '/(content)/adults/exercises/(shared)/positive-imagery/archive'
    | '/(content)/adults/exercises/(shared)/positive-imagery/exercise'
    | '/(content)/adults/exercises/(shared)/positive-imagery/session'
    | '/(content)/adults/exercises/(shared)/social-network/exercise'
    | '/(content)/children/exercises/(shared)/diary-children/archive'
    | '/(content)/children/exercises/(shared)/diary-children/completionView'
    | '/(content)/children/exercises/(shared)/diary-children/exercise'
    | '/(content)/children/exercises/(shared)/happy-place/draw-summary'
    | '/(content)/children/exercises/(shared)/happy-place/drawing-board'
    | '/(content)/children/exercises/(shared)/personal-sources/$step'
    | '/(content)/children/exercises/(shared)/personal-sources/end'
    | '/(content)/children/exercises/(shared)/personal-sources/sessions'
    | '/(content)/children/exercises/(shared)/social-network/exercise'
    | '/(content)/adults/exercises/(shared)/baggage/'
    | '/(content)/adults/exercises/(shared)/body-exercise/'
    | '/(content)/adults/exercises/(shared)/butterfly-hug/'
    | '/(content)/adults/exercises/(shared)/conversing-together/'
    | '/(content)/adults/exercises/(shared)/diary-adults/'
    | '/(content)/adults/exercises/(shared)/drawing/'
    | '/(content)/adults/exercises/(shared)/eft/'
    | '/(content)/adults/exercises/(shared)/finger-breathing/'
    | '/(content)/adults/exercises/(shared)/guided-relaxation/'
    | '/(content)/adults/exercises/(shared)/imagination/'
    | '/(content)/adults/exercises/(shared)/inner-garden/'
    | '/(content)/adults/exercises/(shared)/neurogenic-tremoring/'
    | '/(content)/adults/exercises/(shared)/one-to-five/'
    | '/(content)/adults/exercises/(shared)/painful-memories/'
    | '/(content)/adults/exercises/(shared)/personal-sources/'
    | '/(content)/adults/exercises/(shared)/pleasant-memories/'
    | '/(content)/adults/exercises/(shared)/positive-imagery/'
    | '/(content)/adults/exercises/(shared)/relaxation/'
    | '/(content)/adults/exercises/(shared)/social-network/'
    | '/(content)/adults/exercises/(shared)/three-breath/'
    | '/(content)/adults/exercises/(shared)/tree-of-life/'
    | '/(content)/adults/exercises/(shared)/waterfall/'
    | '/(content)/children/exercises/(shared)/anger-iceberg/'
    | '/(content)/children/exercises/(shared)/body-exercise/'
    | '/(content)/children/exercises/(shared)/circle-of-control/'
    | '/(content)/children/exercises/(shared)/diary-children/'
    | '/(content)/children/exercises/(shared)/finger-breathing/'
    | '/(content)/children/exercises/(shared)/grounding-walk/'
    | '/(content)/children/exercises/(shared)/guided-relaxation/'
    | '/(content)/children/exercises/(shared)/happy-place/'
    | '/(content)/children/exercises/(shared)/humming-bee-breath/'
    | '/(content)/children/exercises/(shared)/my-brave-story/'
    | '/(content)/children/exercises/(shared)/personal-sources/'
    | '/(content)/children/exercises/(shared)/relaxation/'
    | '/(content)/children/exercises/(shared)/social-network/'
    | '/(content)/children/exercises/(shared)/strengths-map/'
    | '/(content)/children/exercises/(shared)/tree-of-life/'
    | '/(content)/adults/exercises/(shared)/personal-sources/summary/$sessionId'
    | '/(content)/children/exercises/(shared)/personal-sources/summary/$sessionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  contentRouteRoute: typeof contentRouteRouteWithChildren
  TrainerRouteRoute: typeof TrainerRouteRouteWithChildren
  AppRoute: typeof AppRoute
  AudienceRoute: typeof AudienceRoute
  IntroductionRoute: typeof IntroductionRoute
  PathRoute: typeof PathRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/path': {
      id: '/path'
      path: '/path'
      fullPath: '/path'
      preLoaderRoute: typeof PathRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/introduction': {
      id: '/introduction'
      path: '/introduction'
      fullPath: '/introduction'
      preLoaderRoute: typeof IntroductionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audience': {
      id: '/audience'
      path: '/audience'
      fullPath: '/audience'
      preLoaderRoute: typeof AudienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trainer': {
      id: '/trainer'
      path: '/trainer'
      fullPath: '/trainer'
      preLoaderRoute: typeof TrainerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(content)': {
      id: '/(content)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof contentRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trainer/profile': {
      id: '/trainer/profile'
      path: '/profile'
      fullPath: '/trainer/profile'
      preLoaderRoute: typeof TrainerProfileRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(content)/profile': {
      id: '/(content)/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof contentProfileRouteImport
      parentRoute: typeof contentRouteRoute
    }
    '/(content)/get-help': {
      id: '/(content)/get-help'
      path: '/get-help'
      fullPath: '/get-help'
      preLoaderRoute: typeof contentGetHelpRouteImport
      parentRoute: typeof contentRouteRoute
    }
    '/(content)/study': {
      id: '/(content)/study'
      path: '/study'
      fullPath: '/study'
      preLoaderRoute: typeof contentStudyRouteRouteImport
      parentRoute: typeof contentRouteRoute
    }
    '/(content)/children': {
      id: '/(content)/children'
      path: '/children'
      fullPath: '/children'
      preLoaderRoute: typeof contentChildrenRouteRouteImport
      parentRoute: typeof contentRouteRoute
    }
    '/(content)/adults': {
      id: '/(content)/adults'
      path: '/adults'
      fullPath: '/adults'
      preLoaderRoute: typeof contentAdultsRouteRouteImport
      parentRoute: typeof contentRouteRoute
    }
    '/trainer/notes/': {
      id: '/trainer/notes/'
      path: '/notes'
      fullPath: '/trainer/notes/'
      preLoaderRoute: typeof TrainerNotesIndexRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/trainer/courses/': {
      id: '/trainer/courses/'
      path: '/courses'
      fullPath: '/trainer/courses/'
      preLoaderRoute: typeof TrainerCoursesIndexRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/trainer/auth/': {
      id: '/trainer/auth/'
      path: '/auth'
      fullPath: '/trainer/auth/'
      preLoaderRoute: typeof TrainerAuthIndexRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/(content)/study/': {
      id: '/(content)/study/'
      path: '/'
      fullPath: '/study/'
      preLoaderRoute: typeof contentStudyIndexRouteImport
      parentRoute: typeof contentStudyRouteRoute
    }
    '/trainer/notes/$courseSlug': {
      id: '/trainer/notes/$courseSlug'
      path: '/notes/$courseSlug'
      fullPath: '/trainer/notes/$courseSlug'
      preLoaderRoute: typeof TrainerNotesCourseSlugRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/trainer/auth/register': {
      id: '/trainer/auth/register'
      path: '/auth/register'
      fullPath: '/trainer/auth/register'
      preLoaderRoute: typeof TrainerAuthRegisterRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/trainer/auth/login': {
      id: '/trainer/auth/login'
      path: '/auth/login'
      fullPath: '/trainer/auth/login'
      preLoaderRoute: typeof TrainerAuthLoginRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/(content)/study/done': {
      id: '/(content)/study/done'
      path: '/done'
      fullPath: '/study/done'
      preLoaderRoute: typeof contentStudyDoneRouteImport
      parentRoute: typeof contentStudyRouteRoute
    }
    '/(content)/study/$wave': {
      id: '/(content)/study/$wave'
      path: '/$wave'
      fullPath: '/study/$wave'
      preLoaderRoute: typeof contentStudyWaveRouteImport
      parentRoute: typeof contentStudyRouteRoute
    }
    '/trainer/courses/$courseSlug/': {
      id: '/trainer/courses/$courseSlug/'
      path: '/courses/$courseSlug'
      fullPath: '/trainer/courses/$courseSlug/'
      preLoaderRoute: typeof TrainerCoursesCourseSlugIndexRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/(content)/children/session/': {
      id: '/(content)/children/session/'
      path: '/session'
      fullPath: '/children/session/'
      preLoaderRoute: typeof contentChildrenSessionIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/': {
      id: '/(content)/children/exercises/'
      path: '/exercises'
      fullPath: '/children/exercises/'
      preLoaderRoute: typeof contentChildrenExercisesIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/adults/exercises/': {
      id: '/(content)/adults/exercises/'
      path: '/exercises'
      fullPath: '/adults/exercises/'
      preLoaderRoute: typeof contentAdultsExercisesIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/trainer/courses/$courseSlug/player': {
      id: '/trainer/courses/$courseSlug/player'
      path: '/courses/$courseSlug/player'
      fullPath: '/trainer/courses/$courseSlug/player'
      preLoaderRoute: typeof TrainerCoursesCourseSlugPlayerRouteImport
      parentRoute: typeof TrainerRouteRoute
    }
    '/(content)/adults/exercises/trauma/': {
      id: '/(content)/adults/exercises/trauma/'
      path: '/exercises/trauma'
      fullPath: '/adults/exercises/trauma/'
      preLoaderRoute: typeof contentAdultsExercisesTraumaIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/suicide-ideation/': {
      id: '/(content)/adults/exercises/suicide-ideation/'
      path: '/exercises/suicide-ideation'
      fullPath: '/adults/exercises/suicide-ideation/'
      preLoaderRoute: typeof contentAdultsExercisesSuicideIdeationIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/substance-use/': {
      id: '/(content)/adults/exercises/substance-use/'
      path: '/exercises/substance-use'
      fullPath: '/adults/exercises/substance-use/'
      preLoaderRoute: typeof contentAdultsExercisesSubstanceUseIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/sleep/': {
      id: '/(content)/adults/exercises/sleep/'
      path: '/exercises/sleep'
      fullPath: '/adults/exercises/sleep/'
      preLoaderRoute: typeof contentAdultsExercisesSleepIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/self-inflicted-injuries/': {
      id: '/(content)/adults/exercises/self-inflicted-injuries/'
      path: '/exercises/self-inflicted-injuries'
      fullPath: '/adults/exercises/self-inflicted-injuries/'
      preLoaderRoute: typeof contentAdultsExercisesSelfInflictedInjuriesIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/physical-pain/': {
      id: '/(content)/adults/exercises/physical-pain/'
      path: '/exercises/physical-pain'
      fullPath: '/adults/exercises/physical-pain/'
      preLoaderRoute: typeof contentAdultsExercisesPhysicalPainIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/nightmares/': {
      id: '/(content)/adults/exercises/nightmares/'
      path: '/exercises/nightmares'
      fullPath: '/adults/exercises/nightmares/'
      preLoaderRoute: typeof contentAdultsExercisesNightmaresIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/guilt-feelings/': {
      id: '/(content)/adults/exercises/guilt-feelings/'
      path: '/exercises/guilt-feelings'
      fullPath: '/adults/exercises/guilt-feelings/'
      preLoaderRoute: typeof contentAdultsExercisesGuiltFeelingsIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/flashbacks/': {
      id: '/(content)/adults/exercises/flashbacks/'
      path: '/exercises/flashbacks'
      fullPath: '/adults/exercises/flashbacks/'
      preLoaderRoute: typeof contentAdultsExercisesFlashbacksIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/depression/': {
      id: '/(content)/adults/exercises/depression/'
      path: '/exercises/depression'
      fullPath: '/adults/exercises/depression/'
      preLoaderRoute: typeof contentAdultsExercisesDepressionIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/concentration/': {
      id: '/(content)/adults/exercises/concentration/'
      path: '/exercises/concentration'
      fullPath: '/adults/exercises/concentration/'
      preLoaderRoute: typeof contentAdultsExercisesConcentrationIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/anxiety/': {
      id: '/(content)/adults/exercises/anxiety/'
      path: '/exercises/anxiety'
      fullPath: '/adults/exercises/anxiety/'
      preLoaderRoute: typeof contentAdultsExercisesAnxietyIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/anger/': {
      id: '/(content)/adults/exercises/anger/'
      path: '/exercises/anger'
      fullPath: '/adults/exercises/anger/'
      preLoaderRoute: typeof contentAdultsExercisesAngerIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/children/exercises/(shared)/tree-of-life/': {
      id: '/(content)/children/exercises/(shared)/tree-of-life/'
      path: '/exercises/tree-of-life'
      fullPath: '/children/exercises/tree-of-life/'
      preLoaderRoute: typeof contentChildrenExercisessharedTreeOfLifeIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/strengths-map/': {
      id: '/(content)/children/exercises/(shared)/strengths-map/'
      path: '/exercises/strengths-map'
      fullPath: '/children/exercises/strengths-map/'
      preLoaderRoute: typeof contentChildrenExercisessharedStrengthsMapIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/social-network/': {
      id: '/(content)/children/exercises/(shared)/social-network/'
      path: '/exercises/social-network'
      fullPath: '/children/exercises/social-network/'
      preLoaderRoute: typeof contentChildrenExercisessharedSocialNetworkIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/relaxation/': {
      id: '/(content)/children/exercises/(shared)/relaxation/'
      path: '/exercises/relaxation'
      fullPath: '/children/exercises/relaxation/'
      preLoaderRoute: typeof contentChildrenExercisessharedRelaxationIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/personal-sources/': {
      id: '/(content)/children/exercises/(shared)/personal-sources/'
      path: '/exercises/personal-sources'
      fullPath: '/children/exercises/personal-sources/'
      preLoaderRoute: typeof contentChildrenExercisessharedPersonalSourcesIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/my-brave-story/': {
      id: '/(content)/children/exercises/(shared)/my-brave-story/'
      path: '/exercises/my-brave-story'
      fullPath: '/children/exercises/my-brave-story/'
      preLoaderRoute: typeof contentChildrenExercisessharedMyBraveStoryIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/humming-bee-breath/': {
      id: '/(content)/children/exercises/(shared)/humming-bee-breath/'
      path: '/exercises/humming-bee-breath'
      fullPath: '/children/exercises/humming-bee-breath/'
      preLoaderRoute: typeof contentChildrenExercisessharedHummingBeeBreathIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/happy-place/': {
      id: '/(content)/children/exercises/(shared)/happy-place/'
      path: '/exercises/happy-place'
      fullPath: '/children/exercises/happy-place/'
      preLoaderRoute: typeof contentChildrenExercisessharedHappyPlaceIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/guided-relaxation/': {
      id: '/(content)/children/exercises/(shared)/guided-relaxation/'
      path: '/exercises/guided-relaxation'
      fullPath: '/children/exercises/guided-relaxation/'
      preLoaderRoute: typeof contentChildrenExercisessharedGuidedRelaxationIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/grounding-walk/': {
      id: '/(content)/children/exercises/(shared)/grounding-walk/'
      path: '/exercises/grounding-walk'
      fullPath: '/children/exercises/grounding-walk/'
      preLoaderRoute: typeof contentChildrenExercisessharedGroundingWalkIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/finger-breathing/': {
      id: '/(content)/children/exercises/(shared)/finger-breathing/'
      path: '/exercises/finger-breathing'
      fullPath: '/children/exercises/finger-breathing/'
      preLoaderRoute: typeof contentChildrenExercisessharedFingerBreathingIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/diary-children/': {
      id: '/(content)/children/exercises/(shared)/diary-children/'
      path: '/exercises/diary-children'
      fullPath: '/children/exercises/diary-children/'
      preLoaderRoute: typeof contentChildrenExercisessharedDiaryChildrenIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/circle-of-control/': {
      id: '/(content)/children/exercises/(shared)/circle-of-control/'
      path: '/exercises/circle-of-control'
      fullPath: '/children/exercises/circle-of-control/'
      preLoaderRoute: typeof contentChildrenExercisessharedCircleOfControlIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/body-exercise/': {
      id: '/(content)/children/exercises/(shared)/body-exercise/'
      path: '/exercises/body-exercise'
      fullPath: '/children/exercises/body-exercise/'
      preLoaderRoute: typeof contentChildrenExercisessharedBodyExerciseIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/anger-iceberg/': {
      id: '/(content)/children/exercises/(shared)/anger-iceberg/'
      path: '/exercises/anger-iceberg'
      fullPath: '/children/exercises/anger-iceberg/'
      preLoaderRoute: typeof contentChildrenExercisessharedAngerIcebergIndexRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/adults/exercises/(shared)/waterfall/': {
      id: '/(content)/adults/exercises/(shared)/waterfall/'
      path: '/exercises/waterfall'
      fullPath: '/adults/exercises/waterfall/'
      preLoaderRoute: typeof contentAdultsExercisessharedWaterfallIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/tree-of-life/': {
      id: '/(content)/adults/exercises/(shared)/tree-of-life/'
      path: '/exercises/tree-of-life'
      fullPath: '/adults/exercises/tree-of-life/'
      preLoaderRoute: typeof contentAdultsExercisessharedTreeOfLifeIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/three-breath/': {
      id: '/(content)/adults/exercises/(shared)/three-breath/'
      path: '/exercises/three-breath'
      fullPath: '/adults/exercises/three-breath/'
      preLoaderRoute: typeof contentAdultsExercisessharedThreeBreathIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/social-network/': {
      id: '/(content)/adults/exercises/(shared)/social-network/'
      path: '/exercises/social-network'
      fullPath: '/adults/exercises/social-network/'
      preLoaderRoute: typeof contentAdultsExercisessharedSocialNetworkIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/relaxation/': {
      id: '/(content)/adults/exercises/(shared)/relaxation/'
      path: '/exercises/relaxation'
      fullPath: '/adults/exercises/relaxation/'
      preLoaderRoute: typeof contentAdultsExercisessharedRelaxationIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/positive-imagery/': {
      id: '/(content)/adults/exercises/(shared)/positive-imagery/'
      path: '/exercises/positive-imagery'
      fullPath: '/adults/exercises/positive-imagery/'
      preLoaderRoute: typeof contentAdultsExercisessharedPositiveImageryIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/pleasant-memories/': {
      id: '/(content)/adults/exercises/(shared)/pleasant-memories/'
      path: '/exercises/pleasant-memories'
      fullPath: '/adults/exercises/pleasant-memories/'
      preLoaderRoute: typeof contentAdultsExercisessharedPleasantMemoriesIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/personal-sources/': {
      id: '/(content)/adults/exercises/(shared)/personal-sources/'
      path: '/exercises/personal-sources'
      fullPath: '/adults/exercises/personal-sources/'
      preLoaderRoute: typeof contentAdultsExercisessharedPersonalSourcesIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/painful-memories/': {
      id: '/(content)/adults/exercises/(shared)/painful-memories/'
      path: '/exercises/painful-memories'
      fullPath: '/adults/exercises/painful-memories/'
      preLoaderRoute: typeof contentAdultsExercisessharedPainfulMemoriesIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/one-to-five/': {
      id: '/(content)/adults/exercises/(shared)/one-to-five/'
      path: '/exercises/one-to-five'
      fullPath: '/adults/exercises/one-to-five/'
      preLoaderRoute: typeof contentAdultsExercisessharedOneToFiveIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/neurogenic-tremoring/': {
      id: '/(content)/adults/exercises/(shared)/neurogenic-tremoring/'
      path: '/exercises/neurogenic-tremoring'
      fullPath: '/adults/exercises/neurogenic-tremoring/'
      preLoaderRoute: typeof contentAdultsExercisessharedNeurogenicTremoringIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/inner-garden/': {
      id: '/(content)/adults/exercises/(shared)/inner-garden/'
      path: '/exercises/inner-garden'
      fullPath: '/adults/exercises/inner-garden/'
      preLoaderRoute: typeof contentAdultsExercisessharedInnerGardenIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/imagination/': {
      id: '/(content)/adults/exercises/(shared)/imagination/'
      path: '/exercises/imagination'
      fullPath: '/adults/exercises/imagination/'
      preLoaderRoute: typeof contentAdultsExercisessharedImaginationIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/guided-relaxation/': {
      id: '/(content)/adults/exercises/(shared)/guided-relaxation/'
      path: '/exercises/guided-relaxation'
      fullPath: '/adults/exercises/guided-relaxation/'
      preLoaderRoute: typeof contentAdultsExercisessharedGuidedRelaxationIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/finger-breathing/': {
      id: '/(content)/adults/exercises/(shared)/finger-breathing/'
      path: '/exercises/finger-breathing'
      fullPath: '/adults/exercises/finger-breathing/'
      preLoaderRoute: typeof contentAdultsExercisessharedFingerBreathingIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/eft/': {
      id: '/(content)/adults/exercises/(shared)/eft/'
      path: '/exercises/eft'
      fullPath: '/adults/exercises/eft/'
      preLoaderRoute: typeof contentAdultsExercisessharedEftIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/drawing/': {
      id: '/(content)/adults/exercises/(shared)/drawing/'
      path: '/exercises/drawing'
      fullPath: '/adults/exercises/drawing/'
      preLoaderRoute: typeof contentAdultsExercisessharedDrawingIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/diary-adults/': {
      id: '/(content)/adults/exercises/(shared)/diary-adults/'
      path: '/exercises/diary-adults'
      fullPath: '/adults/exercises/diary-adults/'
      preLoaderRoute: typeof contentAdultsExercisessharedDiaryAdultsIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/conversing-together/': {
      id: '/(content)/adults/exercises/(shared)/conversing-together/'
      path: '/exercises/conversing-together'
      fullPath: '/adults/exercises/conversing-together/'
      preLoaderRoute: typeof contentAdultsExercisessharedConversingTogetherIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/butterfly-hug/': {
      id: '/(content)/adults/exercises/(shared)/butterfly-hug/'
      path: '/exercises/butterfly-hug'
      fullPath: '/adults/exercises/butterfly-hug/'
      preLoaderRoute: typeof contentAdultsExercisessharedButterflyHugIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/body-exercise/': {
      id: '/(content)/adults/exercises/(shared)/body-exercise/'
      path: '/exercises/body-exercise'
      fullPath: '/adults/exercises/body-exercise/'
      preLoaderRoute: typeof contentAdultsExercisessharedBodyExerciseIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/baggage/': {
      id: '/(content)/adults/exercises/(shared)/baggage/'
      path: '/exercises/baggage'
      fullPath: '/adults/exercises/baggage/'
      preLoaderRoute: typeof contentAdultsExercisessharedBaggageIndexRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/children/exercises/(shared)/social-network/exercise': {
      id: '/(content)/children/exercises/(shared)/social-network/exercise'
      path: '/exercises/social-network/exercise'
      fullPath: '/children/exercises/social-network/exercise'
      preLoaderRoute: typeof contentChildrenExercisessharedSocialNetworkExerciseRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/personal-sources/sessions': {
      id: '/(content)/children/exercises/(shared)/personal-sources/sessions'
      path: '/exercises/personal-sources/sessions'
      fullPath: '/children/exercises/personal-sources/sessions'
      preLoaderRoute: typeof contentChildrenExercisessharedPersonalSourcesSessionsRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/personal-sources/end': {
      id: '/(content)/children/exercises/(shared)/personal-sources/end'
      path: '/exercises/personal-sources/end'
      fullPath: '/children/exercises/personal-sources/end'
      preLoaderRoute: typeof contentChildrenExercisessharedPersonalSourcesEndRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/personal-sources/$step': {
      id: '/(content)/children/exercises/(shared)/personal-sources/$step'
      path: '/exercises/personal-sources/$step'
      fullPath: '/children/exercises/personal-sources/$step'
      preLoaderRoute: typeof contentChildrenExercisessharedPersonalSourcesStepRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/happy-place/drawing-board': {
      id: '/(content)/children/exercises/(shared)/happy-place/drawing-board'
      path: '/exercises/happy-place/drawing-board'
      fullPath: '/children/exercises/happy-place/drawing-board'
      preLoaderRoute: typeof contentChildrenExercisessharedHappyPlaceDrawingBoardRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/happy-place/draw-summary': {
      id: '/(content)/children/exercises/(shared)/happy-place/draw-summary'
      path: '/exercises/happy-place/draw-summary'
      fullPath: '/children/exercises/happy-place/draw-summary'
      preLoaderRoute: typeof contentChildrenExercisessharedHappyPlaceDrawSummaryRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/diary-children/exercise': {
      id: '/(content)/children/exercises/(shared)/diary-children/exercise'
      path: '/exercises/diary-children/exercise'
      fullPath: '/children/exercises/diary-children/exercise'
      preLoaderRoute: typeof contentChildrenExercisessharedDiaryChildrenExerciseRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/diary-children/completionView': {
      id: '/(content)/children/exercises/(shared)/diary-children/completionView'
      path: '/exercises/diary-children/completionView'
      fullPath: '/children/exercises/diary-children/completionView'
      preLoaderRoute: typeof contentChildrenExercisessharedDiaryChildrenCompletionViewRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/children/exercises/(shared)/diary-children/archive': {
      id: '/(content)/children/exercises/(shared)/diary-children/archive'
      path: '/exercises/diary-children/archive'
      fullPath: '/children/exercises/diary-children/archive'
      preLoaderRoute: typeof contentChildrenExercisessharedDiaryChildrenArchiveRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/adults/exercises/(shared)/social-network/exercise': {
      id: '/(content)/adults/exercises/(shared)/social-network/exercise'
      path: '/exercises/social-network/exercise'
      fullPath: '/adults/exercises/social-network/exercise'
      preLoaderRoute: typeof contentAdultsExercisessharedSocialNetworkExerciseRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/positive-imagery/session': {
      id: '/(content)/adults/exercises/(shared)/positive-imagery/session'
      path: '/exercises/positive-imagery/session'
      fullPath: '/adults/exercises/positive-imagery/session'
      preLoaderRoute: typeof contentAdultsExercisessharedPositiveImagerySessionRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/positive-imagery/exercise': {
      id: '/(content)/adults/exercises/(shared)/positive-imagery/exercise'
      path: '/exercises/positive-imagery/exercise'
      fullPath: '/adults/exercises/positive-imagery/exercise'
      preLoaderRoute: typeof contentAdultsExercisessharedPositiveImageryExerciseRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/positive-imagery/archive': {
      id: '/(content)/adults/exercises/(shared)/positive-imagery/archive'
      path: '/exercises/positive-imagery/archive'
      fullPath: '/adults/exercises/positive-imagery/archive'
      preLoaderRoute: typeof contentAdultsExercisessharedPositiveImageryArchiveRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/personal-sources/sessions': {
      id: '/(content)/adults/exercises/(shared)/personal-sources/sessions'
      path: '/exercises/personal-sources/sessions'
      fullPath: '/adults/exercises/personal-sources/sessions'
      preLoaderRoute: typeof contentAdultsExercisessharedPersonalSourcesSessionsRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/personal-sources/end': {
      id: '/(content)/adults/exercises/(shared)/personal-sources/end'
      path: '/exercises/personal-sources/end'
      fullPath: '/adults/exercises/personal-sources/end'
      preLoaderRoute: typeof contentAdultsExercisessharedPersonalSourcesEndRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/personal-sources/$step': {
      id: '/(content)/adults/exercises/(shared)/personal-sources/$step'
      path: '/exercises/personal-sources/$step'
      fullPath: '/adults/exercises/personal-sources/$step'
      preLoaderRoute: typeof contentAdultsExercisessharedPersonalSourcesStepRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/imagination/exercise': {
      id: '/(content)/adults/exercises/(shared)/imagination/exercise'
      path: '/exercises/imagination/exercise'
      fullPath: '/adults/exercises/imagination/exercise'
      preLoaderRoute: typeof contentAdultsExercisessharedImaginationExerciseRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/drawing/summary': {
      id: '/(content)/adults/exercises/(shared)/drawing/summary'
      path: '/exercises/drawing/summary'
      fullPath: '/adults/exercises/drawing/summary'
      preLoaderRoute: typeof contentAdultsExercisessharedDrawingSummaryRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/drawing/mandala': {
      id: '/(content)/adults/exercises/(shared)/drawing/mandala'
      path: '/exercises/drawing/mandala'
      fullPath: '/adults/exercises/drawing/mandala'
      preLoaderRoute: typeof contentAdultsExercisessharedDrawingMandalaRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation': {
      id: '/(content)/adults/exercises/(shared)/diary-adults/exercise-explanation'
      path: '/exercises/diary-adults/exercise-explanation'
      fullPath: '/adults/exercises/diary-adults/exercise-explanation'
      preLoaderRoute: typeof contentAdultsExercisessharedDiaryAdultsExerciseExplanationRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/diary-adults/exercise': {
      id: '/(content)/adults/exercises/(shared)/diary-adults/exercise'
      path: '/exercises/diary-adults/exercise'
      fullPath: '/adults/exercises/diary-adults/exercise'
      preLoaderRoute: typeof contentAdultsExercisessharedDiaryAdultsExerciseRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/diary-adults/diary-template': {
      id: '/(content)/adults/exercises/(shared)/diary-adults/diary-template'
      path: '/exercises/diary-adults/diary-template'
      fullPath: '/adults/exercises/diary-adults/diary-template'
      preLoaderRoute: typeof contentAdultsExercisessharedDiaryAdultsDiaryTemplateRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/diary-adults/archive': {
      id: '/(content)/adults/exercises/(shared)/diary-adults/archive'
      path: '/exercises/diary-adults/archive'
      fullPath: '/adults/exercises/diary-adults/archive'
      preLoaderRoute: typeof contentAdultsExercisessharedDiaryAdultsArchiveRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/conversing-together/exercise': {
      id: '/(content)/adults/exercises/(shared)/conversing-together/exercise'
      path: '/exercises/conversing-together/exercise'
      fullPath: '/adults/exercises/conversing-together/exercise'
      preLoaderRoute: typeof contentAdultsExercisessharedConversingTogetherExerciseRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/adults/exercises/(shared)/conversing-together/archive': {
      id: '/(content)/adults/exercises/(shared)/conversing-together/archive'
      path: '/exercises/conversing-together/archive'
      fullPath: '/adults/exercises/conversing-together/archive'
      preLoaderRoute: typeof contentAdultsExercisessharedConversingTogetherArchiveRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
    '/(content)/children/exercises/(shared)/personal-sources/summary/$sessionId': {
      id: '/(content)/children/exercises/(shared)/personal-sources/summary/$sessionId'
      path: '/exercises/personal-sources/summary/$sessionId'
      fullPath: '/children/exercises/personal-sources/summary/$sessionId'
      preLoaderRoute: typeof contentChildrenExercisessharedPersonalSourcesSummarySessionIdRouteImport
      parentRoute: typeof contentChildrenRouteRoute
    }
    '/(content)/adults/exercises/(shared)/personal-sources/summary/$sessionId': {
      id: '/(content)/adults/exercises/(shared)/personal-sources/summary/$sessionId'
      path: '/exercises/personal-sources/summary/$sessionId'
      fullPath: '/adults/exercises/personal-sources/summary/$sessionId'
      preLoaderRoute: typeof contentAdultsExercisessharedPersonalSourcesSummarySessionIdRouteImport
      parentRoute: typeof contentAdultsRouteRoute
    }
  }
}

interface contentAdultsRouteRouteChildren {
  contentAdultsExercisesIndexRoute: typeof contentAdultsExercisesIndexRoute
  contentAdultsExercisesAngerIndexRoute: typeof contentAdultsExercisesAngerIndexRoute
  contentAdultsExercisesAnxietyIndexRoute: typeof contentAdultsExercisesAnxietyIndexRoute
  contentAdultsExercisesConcentrationIndexRoute: typeof contentAdultsExercisesConcentrationIndexRoute
  contentAdultsExercisesDepressionIndexRoute: typeof contentAdultsExercisesDepressionIndexRoute
  contentAdultsExercisesFlashbacksIndexRoute: typeof contentAdultsExercisesFlashbacksIndexRoute
  contentAdultsExercisesGuiltFeelingsIndexRoute: typeof contentAdultsExercisesGuiltFeelingsIndexRoute
  contentAdultsExercisesNightmaresIndexRoute: typeof contentAdultsExercisesNightmaresIndexRoute
  contentAdultsExercisesPhysicalPainIndexRoute: typeof contentAdultsExercisesPhysicalPainIndexRoute
  contentAdultsExercisesSelfInflictedInjuriesIndexRoute: typeof contentAdultsExercisesSelfInflictedInjuriesIndexRoute
  contentAdultsExercisesSleepIndexRoute: typeof contentAdultsExercisesSleepIndexRoute
  contentAdultsExercisesSubstanceUseIndexRoute: typeof contentAdultsExercisesSubstanceUseIndexRoute
  contentAdultsExercisesSuicideIdeationIndexRoute: typeof contentAdultsExercisesSuicideIdeationIndexRoute
  contentAdultsExercisesTraumaIndexRoute: typeof contentAdultsExercisesTraumaIndexRoute
  contentAdultsExercisessharedConversingTogetherArchiveRoute: typeof contentAdultsExercisessharedConversingTogetherArchiveRoute
  contentAdultsExercisessharedConversingTogetherExerciseRoute: typeof contentAdultsExercisessharedConversingTogetherExerciseRoute
  contentAdultsExercisessharedDiaryAdultsArchiveRoute: typeof contentAdultsExercisessharedDiaryAdultsArchiveRoute
  contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute: typeof contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute
  contentAdultsExercisessharedDiaryAdultsExerciseRoute: typeof contentAdultsExercisessharedDiaryAdultsExerciseRoute
  contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute: typeof contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute
  contentAdultsExercisessharedDrawingMandalaRoute: typeof contentAdultsExercisessharedDrawingMandalaRoute
  contentAdultsExercisessharedDrawingSummaryRoute: typeof contentAdultsExercisessharedDrawingSummaryRoute
  contentAdultsExercisessharedImaginationExerciseRoute: typeof contentAdultsExercisessharedImaginationExerciseRoute
  contentAdultsExercisessharedPersonalSourcesStepRoute: typeof contentAdultsExercisessharedPersonalSourcesStepRoute
  contentAdultsExercisessharedPersonalSourcesEndRoute: typeof contentAdultsExercisessharedPersonalSourcesEndRoute
  contentAdultsExercisessharedPersonalSourcesSessionsRoute: typeof contentAdultsExercisessharedPersonalSourcesSessionsRoute
  contentAdultsExercisessharedPositiveImageryArchiveRoute: typeof contentAdultsExercisessharedPositiveImageryArchiveRoute
  contentAdultsExercisessharedPositiveImageryExerciseRoute: typeof contentAdultsExercisessharedPositiveImageryExerciseRoute
  contentAdultsExercisessharedPositiveImagerySessionRoute: typeof contentAdultsExercisessharedPositiveImagerySessionRoute
  contentAdultsExercisessharedSocialNetworkExerciseRoute: typeof contentAdultsExercisessharedSocialNetworkExerciseRoute
  contentAdultsExercisessharedBaggageIndexRoute: typeof contentAdultsExercisessharedBaggageIndexRoute
  contentAdultsExercisessharedBodyExerciseIndexRoute: typeof contentAdultsExercisessharedBodyExerciseIndexRoute
  contentAdultsExercisessharedButterflyHugIndexRoute: typeof contentAdultsExercisessharedButterflyHugIndexRoute
  contentAdultsExercisessharedConversingTogetherIndexRoute: typeof contentAdultsExercisessharedConversingTogetherIndexRoute
  contentAdultsExercisessharedDiaryAdultsIndexRoute: typeof contentAdultsExercisessharedDiaryAdultsIndexRoute
  contentAdultsExercisessharedDrawingIndexRoute: typeof contentAdultsExercisessharedDrawingIndexRoute
  contentAdultsExercisessharedEftIndexRoute: typeof contentAdultsExercisessharedEftIndexRoute
  contentAdultsExercisessharedFingerBreathingIndexRoute: typeof contentAdultsExercisessharedFingerBreathingIndexRoute
  contentAdultsExercisessharedGuidedRelaxationIndexRoute: typeof contentAdultsExercisessharedGuidedRelaxationIndexRoute
  contentAdultsExercisessharedImaginationIndexRoute: typeof contentAdultsExercisessharedImaginationIndexRoute
  contentAdultsExercisessharedInnerGardenIndexRoute: typeof contentAdultsExercisessharedInnerGardenIndexRoute
  contentAdultsExercisessharedNeurogenicTremoringIndexRoute: typeof contentAdultsExercisessharedNeurogenicTremoringIndexRoute
  contentAdultsExercisessharedOneToFiveIndexRoute: typeof contentAdultsExercisessharedOneToFiveIndexRoute
  contentAdultsExercisessharedPainfulMemoriesIndexRoute: typeof contentAdultsExercisessharedPainfulMemoriesIndexRoute
  contentAdultsExercisessharedPersonalSourcesIndexRoute: typeof contentAdultsExercisessharedPersonalSourcesIndexRoute
  contentAdultsExercisessharedPleasantMemoriesIndexRoute: typeof contentAdultsExercisessharedPleasantMemoriesIndexRoute
  contentAdultsExercisessharedPositiveImageryIndexRoute: typeof contentAdultsExercisessharedPositiveImageryIndexRoute
  contentAdultsExercisessharedRelaxationIndexRoute: typeof contentAdultsExercisessharedRelaxationIndexRoute
  contentAdultsExercisessharedSocialNetworkIndexRoute: typeof contentAdultsExercisessharedSocialNetworkIndexRoute
  contentAdultsExercisessharedThreeBreathIndexRoute: typeof contentAdultsExercisessharedThreeBreathIndexRoute
  contentAdultsExercisessharedTreeOfLifeIndexRoute: typeof contentAdultsExercisessharedTreeOfLifeIndexRoute
  contentAdultsExercisessharedWaterfallIndexRoute: typeof contentAdultsExercisessharedWaterfallIndexRoute
  contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute: typeof contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute
}

const contentAdultsRouteRouteChildren: contentAdultsRouteRouteChildren = {
  contentAdultsExercisesIndexRoute: contentAdultsExercisesIndexRoute,
  contentAdultsExercisesAngerIndexRoute: contentAdultsExercisesAngerIndexRoute,
  contentAdultsExercisesAnxietyIndexRoute:
    contentAdultsExercisesAnxietyIndexRoute,
  contentAdultsExercisesConcentrationIndexRoute:
    contentAdultsExercisesConcentrationIndexRoute,
  contentAdultsExercisesDepressionIndexRoute:
    contentAdultsExercisesDepressionIndexRoute,
  contentAdultsExercisesFlashbacksIndexRoute:
    contentAdultsExercisesFlashbacksIndexRoute,
  contentAdultsExercisesGuiltFeelingsIndexRoute:
    contentAdultsExercisesGuiltFeelingsIndexRoute,
  contentAdultsExercisesNightmaresIndexRoute:
    contentAdultsExercisesNightmaresIndexRoute,
  contentAdultsExercisesPhysicalPainIndexRoute:
    contentAdultsExercisesPhysicalPainIndexRoute,
  contentAdultsExercisesSelfInflictedInjuriesIndexRoute:
    contentAdultsExercisesSelfInflictedInjuriesIndexRoute,
  contentAdultsExercisesSleepIndexRoute: contentAdultsExercisesSleepIndexRoute,
  contentAdultsExercisesSubstanceUseIndexRoute:
    contentAdultsExercisesSubstanceUseIndexRoute,
  contentAdultsExercisesSuicideIdeationIndexRoute:
    contentAdultsExercisesSuicideIdeationIndexRoute,
  contentAdultsExercisesTraumaIndexRoute:
    contentAdultsExercisesTraumaIndexRoute,
  contentAdultsExercisessharedConversingTogetherArchiveRoute:
    contentAdultsExercisessharedConversingTogetherArchiveRoute,
  contentAdultsExercisessharedConversingTogetherExerciseRoute:
    contentAdultsExercisessharedConversingTogetherExerciseRoute,
  contentAdultsExercisessharedDiaryAdultsArchiveRoute:
    contentAdultsExercisessharedDiaryAdultsArchiveRoute,
  contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute:
    contentAdultsExercisessharedDiaryAdultsDiaryTemplateRoute,
  contentAdultsExercisessharedDiaryAdultsExerciseRoute:
    contentAdultsExercisessharedDiaryAdultsExerciseRoute,
  contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute:
    contentAdultsExercisessharedDiaryAdultsExerciseExplanationRoute,
  contentAdultsExercisessharedDrawingMandalaRoute:
    contentAdultsExercisessharedDrawingMandalaRoute,
  contentAdultsExercisessharedDrawingSummaryRoute:
    contentAdultsExercisessharedDrawingSummaryRoute,
  contentAdultsExercisessharedImaginationExerciseRoute:
    contentAdultsExercisessharedImaginationExerciseRoute,
  contentAdultsExercisessharedPersonalSourcesStepRoute:
    contentAdultsExercisessharedPersonalSourcesStepRoute,
  contentAdultsExercisessharedPersonalSourcesEndRoute:
    contentAdultsExercisessharedPersonalSourcesEndRoute,
  contentAdultsExercisessharedPersonalSourcesSessionsRoute:
    contentAdultsExercisessharedPersonalSourcesSessionsRoute,
  contentAdultsExercisessharedPositiveImageryArchiveRoute:
    contentAdultsExercisessharedPositiveImageryArchiveRoute,
  contentAdultsExercisessharedPositiveImageryExerciseRoute:
    contentAdultsExercisessharedPositiveImageryExerciseRoute,
  contentAdultsExercisessharedPositiveImagerySessionRoute:
    contentAdultsExercisessharedPositiveImagerySessionRoute,
  contentAdultsExercisessharedSocialNetworkExerciseRoute:
    contentAdultsExercisessharedSocialNetworkExerciseRoute,
  contentAdultsExercisessharedBaggageIndexRoute:
    contentAdultsExercisessharedBaggageIndexRoute,
  contentAdultsExercisessharedBodyExerciseIndexRoute:
    contentAdultsExercisessharedBodyExerciseIndexRoute,
  contentAdultsExercisessharedButterflyHugIndexRoute:
    contentAdultsExercisessharedButterflyHugIndexRoute,
  contentAdultsExercisessharedConversingTogetherIndexRoute:
    contentAdultsExercisessharedConversingTogetherIndexRoute,
  contentAdultsExercisessharedDiaryAdultsIndexRoute:
    contentAdultsExercisessharedDiaryAdultsIndexRoute,
  contentAdultsExercisessharedDrawingIndexRoute:
    contentAdultsExercisessharedDrawingIndexRoute,
  contentAdultsExercisessharedEftIndexRoute:
    contentAdultsExercisessharedEftIndexRoute,
  contentAdultsExercisessharedFingerBreathingIndexRoute:
    contentAdultsExercisessharedFingerBreathingIndexRoute,
  contentAdultsExercisessharedGuidedRelaxationIndexRoute:
    contentAdultsExercisessharedGuidedRelaxationIndexRoute,
  contentAdultsExercisessharedImaginationIndexRoute:
    contentAdultsExercisessharedImaginationIndexRoute,
  contentAdultsExercisessharedInnerGardenIndexRoute:
    contentAdultsExercisessharedInnerGardenIndexRoute,
  contentAdultsExercisessharedNeurogenicTremoringIndexRoute:
    contentAdultsExercisessharedNeurogenicTremoringIndexRoute,
  contentAdultsExercisessharedOneToFiveIndexRoute:
    contentAdultsExercisessharedOneToFiveIndexRoute,
  contentAdultsExercisessharedPainfulMemoriesIndexRoute:
    contentAdultsExercisessharedPainfulMemoriesIndexRoute,
  contentAdultsExercisessharedPersonalSourcesIndexRoute:
    contentAdultsExercisessharedPersonalSourcesIndexRoute,
  contentAdultsExercisessharedPleasantMemoriesIndexRoute:
    contentAdultsExercisessharedPleasantMemoriesIndexRoute,
  contentAdultsExercisessharedPositiveImageryIndexRoute:
    contentAdultsExercisessharedPositiveImageryIndexRoute,
  contentAdultsExercisessharedRelaxationIndexRoute:
    contentAdultsExercisessharedRelaxationIndexRoute,
  contentAdultsExercisessharedSocialNetworkIndexRoute:
    contentAdultsExercisessharedSocialNetworkIndexRoute,
  contentAdultsExercisessharedThreeBreathIndexRoute:
    contentAdultsExercisessharedThreeBreathIndexRoute,
  contentAdultsExercisessharedTreeOfLifeIndexRoute:
    contentAdultsExercisessharedTreeOfLifeIndexRoute,
  contentAdultsExercisessharedWaterfallIndexRoute:
    contentAdultsExercisessharedWaterfallIndexRoute,
  contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute:
    contentAdultsExercisessharedPersonalSourcesSummarySessionIdRoute,
}

const contentAdultsRouteRouteWithChildren =
  contentAdultsRouteRoute._addFileChildren(contentAdultsRouteRouteChildren)

interface contentChildrenRouteRouteChildren {
  contentChildrenExercisesIndexRoute: typeof contentChildrenExercisesIndexRoute
  contentChildrenSessionIndexRoute: typeof contentChildrenSessionIndexRoute
  contentChildrenExercisessharedDiaryChildrenArchiveRoute: typeof contentChildrenExercisessharedDiaryChildrenArchiveRoute
  contentChildrenExercisessharedDiaryChildrenCompletionViewRoute: typeof contentChildrenExercisessharedDiaryChildrenCompletionViewRoute
  contentChildrenExercisessharedDiaryChildrenExerciseRoute: typeof contentChildrenExercisessharedDiaryChildrenExerciseRoute
  contentChildrenExercisessharedHappyPlaceDrawSummaryRoute: typeof contentChildrenExercisessharedHappyPlaceDrawSummaryRoute
  contentChildrenExercisessharedHappyPlaceDrawingBoardRoute: typeof contentChildrenExercisessharedHappyPlaceDrawingBoardRoute
  contentChildrenExercisessharedPersonalSourcesStepRoute: typeof contentChildrenExercisessharedPersonalSourcesStepRoute
  contentChildrenExercisessharedPersonalSourcesEndRoute: typeof contentChildrenExercisessharedPersonalSourcesEndRoute
  contentChildrenExercisessharedPersonalSourcesSessionsRoute: typeof contentChildrenExercisessharedPersonalSourcesSessionsRoute
  contentChildrenExercisessharedSocialNetworkExerciseRoute: typeof contentChildrenExercisessharedSocialNetworkExerciseRoute
  contentChildrenExercisessharedAngerIcebergIndexRoute: typeof contentChildrenExercisessharedAngerIcebergIndexRoute
  contentChildrenExercisessharedBodyExerciseIndexRoute: typeof contentChildrenExercisessharedBodyExerciseIndexRoute
  contentChildrenExercisessharedCircleOfControlIndexRoute: typeof contentChildrenExercisessharedCircleOfControlIndexRoute
  contentChildrenExercisessharedDiaryChildrenIndexRoute: typeof contentChildrenExercisessharedDiaryChildrenIndexRoute
  contentChildrenExercisessharedFingerBreathingIndexRoute: typeof contentChildrenExercisessharedFingerBreathingIndexRoute
  contentChildrenExercisessharedGroundingWalkIndexRoute: typeof contentChildrenExercisessharedGroundingWalkIndexRoute
  contentChildrenExercisessharedGuidedRelaxationIndexRoute: typeof contentChildrenExercisessharedGuidedRelaxationIndexRoute
  contentChildrenExercisessharedHappyPlaceIndexRoute: typeof contentChildrenExercisessharedHappyPlaceIndexRoute
  contentChildrenExercisessharedHummingBeeBreathIndexRoute: typeof contentChildrenExercisessharedHummingBeeBreathIndexRoute
  contentChildrenExercisessharedMyBraveStoryIndexRoute: typeof contentChildrenExercisessharedMyBraveStoryIndexRoute
  contentChildrenExercisessharedPersonalSourcesIndexRoute: typeof contentChildrenExercisessharedPersonalSourcesIndexRoute
  contentChildrenExercisessharedRelaxationIndexRoute: typeof contentChildrenExercisessharedRelaxationIndexRoute
  contentChildrenExercisessharedSocialNetworkIndexRoute: typeof contentChildrenExercisessharedSocialNetworkIndexRoute
  contentChildrenExercisessharedStrengthsMapIndexRoute: typeof contentChildrenExercisessharedStrengthsMapIndexRoute
  contentChildrenExercisessharedTreeOfLifeIndexRoute: typeof contentChildrenExercisessharedTreeOfLifeIndexRoute
  contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute: typeof contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute
}

const contentChildrenRouteRouteChildren: contentChildrenRouteRouteChildren = {
  contentChildrenExercisesIndexRoute: contentChildrenExercisesIndexRoute,
  contentChildrenSessionIndexRoute: contentChildrenSessionIndexRoute,
  contentChildrenExercisessharedDiaryChildrenArchiveRoute:
    contentChildrenExercisessharedDiaryChildrenArchiveRoute,
  contentChildrenExercisessharedDiaryChildrenCompletionViewRoute:
    contentChildrenExercisessharedDiaryChildrenCompletionViewRoute,
  contentChildrenExercisessharedDiaryChildrenExerciseRoute:
    contentChildrenExercisessharedDiaryChildrenExerciseRoute,
  contentChildrenExercisessharedHappyPlaceDrawSummaryRoute:
    contentChildrenExercisessharedHappyPlaceDrawSummaryRoute,
  contentChildrenExercisessharedHappyPlaceDrawingBoardRoute:
    contentChildrenExercisessharedHappyPlaceDrawingBoardRoute,
  contentChildrenExercisessharedPersonalSourcesStepRoute:
    contentChildrenExercisessharedPersonalSourcesStepRoute,
  contentChildrenExercisessharedPersonalSourcesEndRoute:
    contentChildrenExercisessharedPersonalSourcesEndRoute,
  contentChildrenExercisessharedPersonalSourcesSessionsRoute:
    contentChildrenExercisessharedPersonalSourcesSessionsRoute,
  contentChildrenExercisessharedSocialNetworkExerciseRoute:
    contentChildrenExercisessharedSocialNetworkExerciseRoute,
  contentChildrenExercisessharedAngerIcebergIndexRoute:
    contentChildrenExercisessharedAngerIcebergIndexRoute,
  contentChildrenExercisessharedBodyExerciseIndexRoute:
    contentChildrenExercisessharedBodyExerciseIndexRoute,
  contentChildrenExercisessharedCircleOfControlIndexRoute:
    contentChildrenExercisessharedCircleOfControlIndexRoute,
  contentChildrenExercisessharedDiaryChildrenIndexRoute:
    contentChildrenExercisessharedDiaryChildrenIndexRoute,
  contentChildrenExercisessharedFingerBreathingIndexRoute:
    contentChildrenExercisessharedFingerBreathingIndexRoute,
  contentChildrenExercisessharedGroundingWalkIndexRoute:
    contentChildrenExercisessharedGroundingWalkIndexRoute,
  contentChildrenExercisessharedGuidedRelaxationIndexRoute:
    contentChildrenExercisessharedGuidedRelaxationIndexRoute,
  contentChildrenExercisessharedHappyPlaceIndexRoute:
    contentChildrenExercisessharedHappyPlaceIndexRoute,
  contentChildrenExercisessharedHummingBeeBreathIndexRoute:
    contentChildrenExercisessharedHummingBeeBreathIndexRoute,
  contentChildrenExercisessharedMyBraveStoryIndexRoute:
    contentChildrenExercisessharedMyBraveStoryIndexRoute,
  contentChildrenExercisessharedPersonalSourcesIndexRoute:
    contentChildrenExercisessharedPersonalSourcesIndexRoute,
  contentChildrenExercisessharedRelaxationIndexRoute:
    contentChildrenExercisessharedRelaxationIndexRoute,
  contentChildrenExercisessharedSocialNetworkIndexRoute:
    contentChildrenExercisessharedSocialNetworkIndexRoute,
  contentChildrenExercisessharedStrengthsMapIndexRoute:
    contentChildrenExercisessharedStrengthsMapIndexRoute,
  contentChildrenExercisessharedTreeOfLifeIndexRoute:
    contentChildrenExercisessharedTreeOfLifeIndexRoute,
  contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute:
    contentChildrenExercisessharedPersonalSourcesSummarySessionIdRoute,
}

const contentChildrenRouteRouteWithChildren =
  contentChildrenRouteRoute._addFileChildren(contentChildrenRouteRouteChildren)

interface contentStudyRouteRouteChildren {
  contentStudyWaveRoute: typeof contentStudyWaveRoute
  contentStudyDoneRoute: typeof contentStudyDoneRoute
  contentStudyIndexRoute: typeof contentStudyIndexRoute
}

const contentStudyRouteRouteChildren: contentStudyRouteRouteChildren = {
  contentStudyWaveRoute: contentStudyWaveRoute,
  contentStudyDoneRoute: contentStudyDoneRoute,
  contentStudyIndexRoute: contentStudyIndexRoute,
}

const contentStudyRouteRouteWithChildren =
  contentStudyRouteRoute._addFileChildren(contentStudyRouteRouteChildren)

interface contentRouteRouteChildren {
  contentAdultsRouteRoute: typeof contentAdultsRouteRouteWithChildren
  contentChildrenRouteRoute: typeof contentChildrenRouteRouteWithChildren
  contentStudyRouteRoute: typeof contentStudyRouteRouteWithChildren
  contentGetHelpRoute: typeof contentGetHelpRoute
  contentProfileRoute: typeof contentProfileRoute
}

const contentRouteRouteChildren: contentRouteRouteChildren = {
  contentAdultsRouteRoute: contentAdultsRouteRouteWithChildren,
  contentChildrenRouteRoute: contentChildrenRouteRouteWithChildren,
  contentStudyRouteRoute: contentStudyRouteRouteWithChildren,
  contentGetHelpRoute: contentGetHelpRoute,
  contentProfileRoute: contentProfileRoute,
}

const contentRouteRouteWithChildren = contentRouteRoute._addFileChildren(
  contentRouteRouteChildren,
)

interface TrainerRouteRouteChildren {
  TrainerProfileRoute: typeof TrainerProfileRoute
  TrainerAuthLoginRoute: typeof TrainerAuthLoginRoute
  TrainerAuthRegisterRoute: typeof TrainerAuthRegisterRoute
  TrainerNotesCourseSlugRoute: typeof TrainerNotesCourseSlugRoute
  TrainerAuthIndexRoute: typeof TrainerAuthIndexRoute
  TrainerCoursesIndexRoute: typeof TrainerCoursesIndexRoute
  TrainerNotesIndexRoute: typeof TrainerNotesIndexRoute
  TrainerCoursesCourseSlugPlayerRoute: typeof TrainerCoursesCourseSlugPlayerRoute
  TrainerCoursesCourseSlugIndexRoute: typeof TrainerCoursesCourseSlugIndexRoute
}

const TrainerRouteRouteChildren: TrainerRouteRouteChildren = {
  TrainerProfileRoute: TrainerProfileRoute,
  TrainerAuthLoginRoute: TrainerAuthLoginRoute,
  TrainerAuthRegisterRoute: TrainerAuthRegisterRoute,
  TrainerNotesCourseSlugRoute: TrainerNotesCourseSlugRoute,
  TrainerAuthIndexRoute: TrainerAuthIndexRoute,
  TrainerCoursesIndexRoute: TrainerCoursesIndexRoute,
  TrainerNotesIndexRoute: TrainerNotesIndexRoute,
  TrainerCoursesCourseSlugPlayerRoute: TrainerCoursesCourseSlugPlayerRoute,
  TrainerCoursesCourseSlugIndexRoute: TrainerCoursesCourseSlugIndexRoute,
}

const TrainerRouteRouteWithChildren = TrainerRouteRoute._addFileChildren(
  TrainerRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  contentRouteRoute: contentRouteRouteWithChildren,
  TrainerRouteRoute: TrainerRouteRouteWithChildren,
  AppRoute: AppRoute,
  AudienceRoute: AudienceRoute,
  IntroductionRoute: IntroductionRoute,
  PathRoute: PathRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  WelcomeRoute: WelcomeRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
